export default {
    id: "ID",
    dashboard: "ड्यासबोर्ड",
    warning: "चेतावनी",
    users: "प्रयोगकर्ताहरू",
    farms: "खेतहरू",
    animals: "जनावरहरू",
    action: "कार्य",
    actionList: "कार्य सूची",
    drugInventory: "औषधि सूची",
    inseminatorStatistics: "इन्सेमिनेटर तथ्याङ्क",
    organizationNTR: "संगठन NTR",
    genotypePerformance: "जीनोटाइप प्रदर्शन",
    semenAutomation: "वीर्य स्वचालन",
    activityLogs: "गतिविधि लग",
    username: "प्रयोगकर्ता नाम",
    title: "शीर्षक",
    deactivated: "निष्क्रिय पारियो",
    name: "नाम",
    email: "इमेल",
    emailAddress: "इ - मेल ठेगाना",
    mobileNum: "मोबाइल नम्बर",
    emailOrMobile: "इमेल/मोबाइल",
    role: "भूमिका",
    roles: "भूमिकाहरू",
    department: "विभाग",
    status: "स्थिति",
    pages: "पृष्ठहरू",
    departments: "विभागहरू",
    password: "पासवर्ड",
    cancel: "रद्द गर्नुहोस्",
    submit: "पेश गर्नुहोस्",
    error: "त्रुटि",
    success: "सफलता",
    Browse: "ब्राउज गर्नुहोस्",
    orDropYourFileCsvXlsXlsxHere: "वा तपाईंको फाइल (CSV, XLS, XLSx) यहाँ ड्रप गर्नुहोस्",
    search: "खोज्नुहोस्",
    apply: "निवेदन गर्नु",
    select: "चयन गर्नुहोस्",
    previous: "अघिल्लो",
    mandatory: "अनिवार्य",
    dropYourFileHere: "वा तपाईंको फाइल (CSV, XLS, XLSx, PDF, Docx, PNG, JPEG) यहाँ ड्रप गर्नुहोस्",
    restoreDefault: "पूर्वनिर्धारित पुनर्स्थापना",
    pending: "विचाराधीन",
    completed: "पूरा भयो",
    remove: "हटाउनुहोस्",
    update: "अपडेट गर्नुहोस्",
    removeFile: "फाइल हटाउनुहोस्",
    uploadFile: "फाइल अपलोड गर्नुहोस्",
    pleaseChoosePreferedLanguage: "कृपया आफ्नो मनपर्ने भाषा छान्नुहोस्",
    edit: "सम्पादन गर्नुहोस्",
    activate: "सक्रिय गर्नुहोस्",
    deactivate: "निष्क्रिय पार्नुहोस्",
    recievedOrders: "प्राप्त आदेशहरू",
    chartRepresentation: "चार्ट प्रतिनिधित्व",
    nameIsRequired: "नाम आवश्यक छ",
    export: "निर्यात गर्नुहोस्",
    noFilesAvailable: "कुनै फाइलहरू उपलब्ध छैनन्",
    selectDepartmentToshowRoles: "भूमिकाहरू देखाउनको लागि विभाग चयन गर्नुहोस्",
    selectDepartmentWithActiveRoles: "सक्रिय भूमिका भएको विभाग छान्नुहोस्",
    nameCanContainOnlyAlphabets: "नाममा अक्षर मात्र समावेश हुन सक्छ",
    nameMustBeLessThan15Chars: "नाम 30 वर्ण भन्दा कम हुनु पर्छ",
    emailRequired: "इमेल आवश्यक छ",
    invalidEmailFormat: "अवैध इमेल ढाँचा",
    mobNumReq: "मोबाइल नम्बर आवश्यक छ",
    invalidMobFormat: "अवैध मोबाइल नम्बर ढाँचा।",
    passwordRequired: "पासवर्ड आवश्यक छ",
    departmentReq: "विभाग आवश्यक छ",
    roleReq: "भूमिका आवश्यक छ",
    unableToUpdate: "अपडेट गर्न सकिएन",
    orignalName: "मूल नाम",
    uploadedDate: "अपलोड गरिएको मिति",
    fileName: "फाइल नाम",
    importNum: "आयात नम्बर",
    languagePreferences: "भाषा प्राथमिकता",
    pleaseTryAgainAfterSometime: "कृपया केहि समय पछि प्रयास गर्नुहोस्",
    noChanges: "कुनै परिवर्तन छैन",
    nothingchanged: "केही परिवर्तन भएको छैन",
    pleaseChooseAnImageFile: "कृपया एउटा छवि फाइल छान्नुहोस्",
    fileIsTooBigSelectUnder1MB: "तपाईंको फाइल धेरै ठूलो छ! ",
    phoneShouldHave10Chars: "फोनमा १० वर्ण हुनुपर्छ",
    onlyCSVAllowed: "CSV फाइल मात्र अनुमति छ",
    loadingPleaseWait: "लोड हुँदै... कृपया प्रतीक्षा गर्नुहोस्",
    manager: "प्रबन्धक",
    administrator: "प्रशासक",
    Comingsoon: "आउदैछ",
    totalAnimals: "कुल जनावरहरू",
    receivedOrders: "प्राप्त आदेशहरू",
    drugs: "ड्रग्स",
    detailedAnalysis: "विस्तृत विश्लेषण",
    barGraphRepOfActiveUsersAndDeactivateUsers: "सक्रिय प्रयोगकर्ता र निष्क्रिय प्रयोगकर्ताहरूको बार ग्राफ प्रतिनिधित्व",
    barGraphRepOfRegAnimalsVsFarm: "रेजिष्टर्ड जनावर बनाम फार्म को बार ग्राफ प्रतिनिधित्व",
    roleNumber: "भूमिका नम्बर",
    roleName: "भूमिकाको नाम",
    active: "सक्रिय",
    inactive: "निष्क्रिय",
    admin: "व्यवस्थापक",
    addRole: "भूमिका थप्नुहोस्",
    addRoles: "भूमिकाहरू थप्नुहोस्",
    permissions: "अनुमतिहरू",
    sr: "Sr",
    moduleName: "मोड्युल नाम",
    view: "हेर्नुहोस्",
    deptNo: "विभाग नं.",
    selectByCategory: "श्रेणी द्वारा चयन गर्नुहोस्",
    weeklyAnalytics: "साप्ताहिक विश्लेषण",
    pregnancy: "गर्भावस्था",
    analytics: "विश्लेषण",
    calendar: "पात्रो",
    productName: "उत्पादनको नाम",
    volumeSold: "मात्रा बेचियो",
    recordPoints: "रेकर्ड अंक",
    inStock: "स्टक मा",
    revenue: "राजस्व",
    stockStatus: "स्टक स्थिति",
    barChart: "बार चार्ट",
    lineChart: "रेखा चार्ट",
    indexReturns: "सूचकांक रिटर्न",
    chart: "चार्ट",
    time: "समय",
    production: "उत्पादन",
    customization: "अनुकूलन",
    recordsPerPage: "प्रति पृष्ठ रेकर्डहरू",
    noDataAvailable: "कुनै डाटा उपलब्ध छैन",
    reporting: "रिपोर्टिङ",
    optional: "ऐच्छिक",
    note: "नोट",
    notes: "नोटहरू",
    date: "मिति",
    kG: "के। जि",
    weight: "वजन",
    type: "टाइप गर्नुहोस्",
    lessthan3Month: "<3 महिना",
    lessthan6Month: "<6 महिना",
    lessthan7Month: "<7 महिना",
    lastWeek: "गएको हप्ता",
    thisWeek: "यो हप्ता",
    lessthanOneYear: "<1 वर्ष",
    lessthanTwoYear: "<२ वर्ष",
    lessthanThreeYear: "<3 वर्ष",
    lessthanFourYear: "<4 वर्ष",
    yes: "हो",
    no: "छैन",
    of: "को",
    notSpecified: "तोकिएको छैन",
    days: "दिनहरू",
    day: "दिन",
    aDay: "एक दिन",
    years: "वर्ष",
    year: "वर्ष",
    unit: "एकाइ",
    units: "एकाइहरू",
    to: "को",
    profile: "प्रोफाइल",
    logOut: "बाहिर निस्कनु",
    Unit: "एकाइ",
    otherSettings: "अन्य सेटिङहरू",
    somethingWentWrong: "केहि गलत भयो।",
    toDo: "गर्नु पर्ने",
    loadingData: "डाटा लोड गर्दै...",
    taskNumber: "कार्य नम्बर",
    taskName: "कार्यको नाम",
    startDate: "सुरू मिति",
    dueDate: "अन्तिम मिति",
    reason: "कारण",
    quantity: "मात्रा",
    cost: "लागत",
    noRecordFound: "कुनै रेकर्ड फेला परेन",
    dailyUpdates: "दैनिक अपडेटहरू",
    weeklyUpdates: "साप्ताहिक अपडेटहरू",
    moduleAccessed: "मोड्युल पहुँच",
    typesOfAccess: "पहुँचका प्रकारहरू",
    userId: "प्रयोगकर्ता ID",
    lastLogin: "पछिल्लो लगइन",
    terminalID: "टर्मिनल आईडी",
    geographicalAccessPoint: "भौगोलिक पहुँच बिन्दु",
    iPAddress: "आईपी ​​ठेगाना",
    fileAccessed: "फाइल पहुँच",
    functionAccessed: "कार्य पहुँच",
    webPageURL: "वेब पृष्ठ URL",
    accessType: "पहुँच प्रकार",
    unsuccessfulLoginAttempts: "असफल लगइन प्रयासहरू",
    customerAddress: "ग्राहक ठेगाना",
    orderdate: "अर्डर मिति",
    postageDate: "हुलाक मिति",
    postID: "पोस्ट आईडी",
    packingTechnician: "प्याकिङ प्राविधिक",
    packingTechnicia: "प्याकिंग प्राविधिक",
    packEdit: "प्याक सम्पादन गर्नुहोस्",
    batchNumber: "ब्याच नम्बर",
    collectionTechnician: "सङ्कलन प्राविधिक",
    collectionTechnicia: "सङ्कलन प्राविधिक",
    preparationTechnicia: "प्राविधिक तयारी",
    preparationTechnician: "तयारी प्राविधिक",
    approvedManually: "म्यानुअल रूपमा स्वीकृत",
    researcher: "अनुसन्धानकर्ता",
    dateOfApproval: "स्वीकृति मिति",
    approvalEdit: "स्वीकृति सम्पादन",
    searchByAllExceptDate: "मिति बाहेक सबै खोज्नुहोस्",
    approval: "स्वीकृति",
    collection: "सङ्कलन",
    postage: "हुलाक",
    pack: "प्याक",
    straws: "परालहरू",
    createdAt: "मा सिर्जना गरियो",
    sireID: "सर आईडी",
    economicIndexValue: "आर्थिक सूचकांक मूल्य",
    latestCollectionDate: "पछिल्लो संग्रह मिति",
    locationId: "स्थान आईडी",
    lastUpdated: "पछिल्लो अपडेट",
    print: "छाप्नुहोस्",
    save: "बचत गर्नुहोस्",
    tax: "कर",
    phoneNo: "फोन नं",
    exportAsPDF: "PDF को रूपमा निर्यात गर्नुहोस्",
    statusUpdated: "स्थिति अद्यावधिक गरियो",
    statusNotUpdated: "स्थिति अद्यावधिक गरिएको छैन",
    inProgress: "प्रगति हुदैछ",
    assignedTo: "खटाइएका",
    taskId: "टास्क आईडी",
    createdDate: "मिति सिर्जना गरियो",
    numberOfAnimals: "जनावरहरूको संख्या",
    healthRecordSubmittedSuccess: "स्वास्थ्य अभिलेख सफलतापूर्वक पेश गरियो",
    healthRecordSubmitted: "स्वास्थ्य अभिलेख पेश गरियो।",
    InseminationRecordSubmittedSuccesful: "गर्भाधान रेकर्ड सफलतापूर्वक पेश गरियो",
    inseminationRecordSubmitted: "गर्भाधान अभिलेख पेश गरियो।",
    actionListDailyTask: "कार्य सूची - दैनिक कार्य",
    sinceLastYear: "गत वर्ष देखि",
    sinceLastQuarter: "पछिल्लो क्वार्टर देखि",
    sinceLastMonth: "गत महिना देखि",
    sinceLastWeek: "गत हप्ता देखि",
    drugWithdrawPeriod: "औषधि निकाल्ने अवधि",
    diagnosisName: "निदान नाम",
    animalWithNoGenetype: "यो जनावरसँग कुनै जीनोटाइप डाटा दर्ता गरिएको छैन। ",
    nameOfPreviousOwner: "अघिल्लो मालिकको नाम",
    avatarSize: "अवतार साइज १ MB भन्दा कम हुनुपर्छ!",
    testDestination: "परीक्षण गन्तव्य",
    animalNotAdded: "जनावर थपिएको छैन",
    registerationSuccessful: "दर्ता सफल",
    backToAnimalList: "जनावरहरूको सूचीमा फर्कनुहोस्",
    addAnotherAnimal: "अर्को जनावर थप्नुहोस्",
    animalDetailsUpdated: "पशु विवरणहरू सफलतापूर्वक अद्यावधिक गरियो",
    animalUpdatedSuccessfully: "जनावर सफलतापूर्वक अद्यावधिक गरियो",
    animalNotUpdated: "जनावर अद्यावधिक गरिएको छैन",
    notMember: "सदस्य होइन?",
    requestAccess: "पहुँच अनुरोध गर्नुहोस्",
    typePassword: "कृपया पासवर्ड टाइप गर्नुहोस्।",
    minChars: "न्यूनतम 6 वर्ण",
    typeConfirmPassword: "कन्फर्म पासवर्ड टाइप गर्नुहोस्",
    passConfig: "पासवर्ड पुष्टिकरण मेल खाँदैन।",
    invalidEmailMobile: "अवैध इमेल/मोबाइल ढाँचा",
    passwordNotEmpty: "पासवर्ड खाली हुन सक्दैन",
    passwordLength: "पासवर्डको लम्बाइ ८ वर्णभन्दा कम हुन सक्दैन",
    cityVillage: "शहर / गाउँ",
    districtRegion: "जिल्ला / क्षेत्र",
    alreadyHaveAnAccount: "पहिले नै खाता छ?",
    genetypeUpdated: "GenoType अद्यावधिक गरियो",
    genetypeNotUpdated: "GenoType अद्यावधिक गरिएको छैन",
    sellTrade: "बेच्नुहोस्/व्यापार गर्नुहोस्",
    milkingDevon: "मिल्किङ डेभन प्रजनन स्टक बिक्रीको लागि",
    detailedDescription: "विस्तृत विवरण",
    longPara: "अमेरिकी मिल्किङ डेभन बुल्स हेफर र गाई। ",
    contactSeller: "बिक्रेतालाई सम्पर्क गर्नुहोस्",
    enterListingTitle: "सूची शीर्षक प्रविष्ट गर्नुहोस्",
    livestocktype: "पशुधनको प्रकार",
    uploadImage: "एउटा छवि अपलोड गर्नुहोस्",
    mobilePhone: "मोबाइल फोन नम्बर",
    myLivestock: "मेरो पशुधन",
    livestockObservations: "पशुधन अवलोकन",
    selectFromRegisteredAnimals: "दर्ता गरिएका जनावरहरूको सूचीबाट चयन गर्नुहोस्",
    selectOption: "विकल्प चयन गर्नुहोस्",
    selectTypeObservation: "अवलोकनको प्रकार चयन गर्नुहोस्",
    attachVeteinaryDocument: "पशु चिकित्सा कागजात संलग्न गर्नुहोस्",
    addsensorReading: "सेन्सर पढाइ थप्नुहोस्",
    myDocument: "मेरा कागजातहरु",
    enterAKeyword: "कुञ्जी शब्द प्रविष्ट गर्नुहोस्",
    documentType: "कागजात प्रकार",
    registerEditLivestock: "पशुधन दर्ता/सम्पादन गर्नुहोस्",
    editLivestockProfile: "पशुधन प्रोफाइल सम्पादन गर्नुहोस्",
    copy: "कापी",
    dateOfRegister: "दर्ता मिति",
    livestockType: "पशुधनको प्रकार",
    registerNewLivestock: "नयाँ पशुधन दर्ता गर्नुहोस्",
    enterUniqueTag: "अद्वितीय ट्याग प्रविष्ट गर्नुहोस्",
    color: "रङ",
    gender: "लिङ्ग",
    male: "पुरुष",
    female: "महिला",
    damm: "बाँध",
    siree: "हजुर",
    dateOfSaleAuction: "बिक्री/लिलामी बिक्रीको मिति",
    auctionRecord: "मृत्युसूचीको लिलामी रेकर्ड",
    distinguishingFeatures: "भेदभाव सुविधाहरू",
    keywordListing: "कीवर्ड वा सूची आईडी",
    adType: "विज्ञापन प्रकार",
    activeListingFund: "१ सक्रिय सूची फेला पर्यो",
    setupSensors: "सेन्सरहरू सेट अप गर्नुहोस्",
    serialNumber: "क्रम संख्या",
    sensorLocation: "सेन्सर स्थान",
    sensorType: "सेन्सर प्रकार",
    installationDate: "स्थापना मिति",
    ExpirationDate: "म्याद समाप्त हुने मिति",
    addGeo: "जियोलोकेशन थप्नुहोस्",
    addMoreSensors: "थप सेन्सरहरू थप्नुहोस्",
    trackAndTrace: "ट्र्याक र ट्रेस",
    createNewShipment: "नयाँ ढुवानी सिर्जना गर्नुहोस्",
    workflowReference: "कार्यप्रवाह सन्दर्भ",
    invoiceDate: "इनभ्वाइस मिति",
    trackShipment: "ढुवानी ट्र्याक गर्नुहोस्",
    totalShipments: "कुल ढुवानी",
    activeShipment: "सक्रिय ढुवानी",
    completedObjectives: "पूरा गरिएका उद्देश्यहरू",
    processedPayments: "प्रशोधित भुक्तानीहरू",
    pointOfDestination: "गन्तव्यको बिन्दु",
    sellerInformation: "बिक्रेता जानकारी",
    selectSellerConsignor: "विक्रेता/प्रेषक चयन गर्नुहोस्",
    pointOfOrigin: "उत्पत्ति बिन्दु",
    buyerInfo: "क्रेता जानकारी",
    selectBuyerConsignor: "क्रेता/प्रेषक चयन गर्नुहोस्",
    addSensorTriggers: "सेन्सर ट्रिगरहरू थप्नुहोस्",
    processPayments: "प्रक्रिया भुक्तानी",
    defineShippingContract: "ढुवानी सम्झौता परिभाषित गर्नुहोस्",
    addDigitize: "थप्नुहोस्",
    currentlyOnFarm: "हाल फार्म मा",
    addSire: "सर थप्नुहोस्",
    addApproval: "स्वीकृति थप्नुहोस्",
    addCollection: "सङ्कलन थप्नुहोस्",
    addStraws: "स्ट्राहरू थप्नुहोस्",
    addPack: "प्याक थप्नुहोस्",
    addPostage: "हुलाक थप्नुहोस्",
    searchBySire: "सर द्वारा खोज्नुहोस्",
    anyDataChangeMightBeLost: "कुनै पनि डाटा परिवर्तन हराउन सक्छ",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "तपाईं बचत गर्न चाहनुहुन्छ वा बचत नगरी छोड्न चाहनुहुन्छ",
    leave: "छोड",
    stay: "रहनुहोस्",
    animalFarm: "पशु फार्म",
    animalFarmH: "पशु फार्म",
    animalOrigin: "पशु उत्पत्ति",
    animalOriginH: "पशु उत्पत्ति",
    farmOfOrigin: "उत्पत्तिको खेत",
    farmOfOriginH: "उत्पत्तिको खेत",
    selectFarm: "फार्म चयन गर्नुहोस्",
    searchFarm: "फार्म खोज्नुहोस्",
    confirmation: "पुष्टि",
    proceed: "अगाडि बढ्नुहोस्",
    ok: "ठिक छ",
    animal: {
      tagH: "ट्याग",
      tagNumberH: "ट्याग नम्बर: तपाईले रंग र संख्या थप्न सक्नुहुन्छ। ",
      goveRegNoH: "पहिचान विवरणहरू जसमा व्यक्तिको नाम र ठेगाना, प्रक्रियाको सेवाको लागि व्यक्तिको एजेन्ट, प्रदर्शन गरिने गतिविधिको स्थान, र व्यक्तिले प्रदान गर्ने सेवाको विवरण समावेश हुन सक्छ।",
      birthWeightH: "बाछोको जन्म वजन",
      birthEaseH: "पशुधनमा जन्मनु एक प्राकृतिक प्रक्रिया हो तर कहिलेकाहीं त्यहाँ जन्म समस्याहरू हुन सक्छ जहाँ बाँधलाई किसान / पशुपालकको सहयोग चाहिन्छ।",
      birthFarmH: "पशु उत्पत्ति/जन्मको फार्म।",
      surrogateDamH: "पोथी गाईको आईडी जसमा दाता नर र दाता महिलाबाट निषेचित अण्डा यसको थप विकासको लागि प्रत्यारोपण गरिन्छ।",
      ownerH: "यो जनावरको मालिकको नाम हो।",
      damH: "महिला अभिभावक/पशुको आमाको आईडी।",
      sireH: "जनावरको पुरुष अभिभावक/बुवाको आईडी।",
      breedH: "एक नस्ल एक समान उपस्थिति (फेनोटाइप), एकसमान व्यवहार, र/वा अन्य विशेषताहरू भएका घरेलु जनावरहरूको एक विशिष्ट समूह हो जसले यसलाई समान प्रजातिका अन्य जीवहरूबाट अलग गर्दछ।",
      conceptionMethodH: "जनावरको गर्भ कसरी भयो।",
      genderH: "जनावरको लिंग।",
      dobH: "जनावरको जन्म मिति।",
      operatorH: "यो जनावरको जानकारी भर्ने व्यक्तिको नाम।",
      removalFarmH: "पशु हटाइएको फार्म ",
      dateOfRemovalH: "जनावर हटाउने मिति",
      destinationOfRemoval: "हटाइएका जनावरको गन्तव्य स्थान",
      reasonOfRemovalH: "पशु हटाउने कारण",
      trackingNumberH: "जनावर हटाइँदा जनावरलाई तोकिएको नम्बर",
      brandH: "ब्रान्ड - केवल स्थायी चिन्ह जुन गाईमा जलाइएको थियो।",
      tattoH: "जनावर मा ट्याटू।",
      hornStatusH: "जनावरलाई निर्दोष छ कि छैन।",
      animalOriginH: "जनावरको उत्पत्तिको देश।",
      previousOwnerH: "परिपक्व भएको अवस्थामा पशुको अघिल्लो मालिकको नाम।",
      twinH: "यस क्षेत्रले जनावरको जुम्ल्याहा छ कि छैन भनेर बताउँछ।",
      regBreedAssoNoH: "नस्ल संघ / समाज संग दर्ता।",
      breedAssoNameH: "पशु दर्ता भएको संघ/समाजको नाम",
      breederH: "यो पशु आपूर्ति गर्ने संस्थाको नाम हो।",
      breeder: "ब्रीडर",
      noteH: "जनावरको बारेमा महत्त्वपूर्ण नोट (हरू)।",
      accuracyWeight_for_field: "शुद्धता वजन",
      conception: "अवधारणा",
      addAnAnimal: "एउटा जनावर थप्नुहोस्",
      addAnimal: "जनावर थप्नुहोस्",
      registerAnAnimal: "जनावर दर्ता गर्नुहोस्",
      uploadAnAnimal: "एउटा जनावर अपलोड गर्नुहोस्",
      animalRegistration: "पशु दर्ता",
      animalDetails: "पशु विवरण",
      tag: "ट्याग",
      tagNumber: "ट्याग नम्बर",
      govtRegNumber: "सरकार ",
      birthWeight: "जन्म वजन",
      birthEase: "जन्म सहजता",
      birthFarm: "जन्म फार्म",
      surrogateDam: "सरोगेट बाँध",
      owner: "मालिक",
      ownershipType: "स्वामित्वको प्रकार",
      animalDiseaseRecord: "पशु रोग रेकर्ड",
      govtReg: "सरकार ",
      regDate: "दर्ता मिति",
      dam: "बाँध",
      sire: "हजुर",
      heifer: "हेफर",
      steer: "स्टेयर",
      calf: "बाछो",
      farmHerd: "खेत / बथान",
      femaleCalf: "महिला बाछो",
      maleCalf: "नर बाछो",
      newCalves: "नयाँ बाछो",
      breed: "नस्ल",
      conceptionMethod: "अवधारणा विधि",
      gender: "लिङ्ग",
      dateOfBirth: "जन्म मिति",
      operator: "अपरेटर",
      animalRemovedFarm: "पशु हटाइएको फार्म",
      dateOfAnimalRemoval: "पशु हटाउने मिति",
      destinationOfRemovedAnimal: "हटाइएका जनावरको गन्तव्य",
      reasonOfRemoval: "हटाउनुको कारण",
      optionalAnimalInformation: "वैकल्पिक पशु जानकारी",
      animalPicture: "पशु चित्र",
      trackingNumber: "ट्र्याकिङ नम्बर",
      brand: "ब्रान्ड",
      tatto: "ट्याटु",
      hornStatus: "हर्न स्थिति",
      animalOrigin: "पशु उत्पत्ति",
      previosOwner: "अघिल्लो मालिक",
      twin: "जुम्ल्याहा",
      InABreedAssociation: "Reg.",
      nameOfBreedAssociations: "नस्ल संघहरूको नाम",
      breedAssociations: "नस्ल संघहरू",
      breederSupplier: "ब्रीडर (आपूर्तिकर्ता)",
      importAnimal: "पशु आयात गर्नुहोस्",
      loadingAnimals: "जनावरहरू लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      totalRegAnimals: "कुल Reg. ",
      totalPregnantAnimals: "कुल गर्भवती जनावरहरू",
      pregnantAnimalHistory: "गर्भवती पशु इतिहास",
      dailyAnimalPregnancyUpdates: "दैनिक पशु गर्भावस्था अपडेटहरू",
      animalHistory: "पशु इतिहास",
      dailyAnimalUpdates: "दैनिक पशु अपडेटहरू",
      totalPregnant: "कुल गर्भवती",
      totalNewBorn: "कुल नयाँ जन्म",
      searchByIDGOVRegTag: "ID, GOV Reg र ट्याग द्वारा खोज्नुहोस्",
      noANIMALAVAILABLE: "कुनै पनि जनावर उपलब्ध छैन",
      associationNumber: "संघ नम्बर",
      associationName: "संघको नाम",
      destinationName: "गन्तव्य नाम",
      plastic: "प्लास्टिक",
      metal: "धातु",
      naturalMating: "प्राकृतिक मिलन",
      artificialInsemination: "कृत्रिम गर्भाधान",
      embryoTransfer: "भ्रूण स्थानान्तरण",
      noAssistance: "कुनै सहयोग छैन",
      someAssistance: "केही सहयोग",
      mechanicalAssistance: "मेकानिकल सहायता",
      aCesareanSection: "सिजेरियन सेक्शन",
      abnormalDelivery: "असामान्य वितरण",
      male: "पुरुष",
      female: "महिला",
      sale: "बिक्री",
      slaughter: "वध",
      death: "मृत्यु",
      theft: "चोरी",
      other: "अन्य",
      horned: "सिङ भएको",
      polled: "मतदान भयो",
      dehorned: "Dehorned",
      details: "विवरणहरू",
      performance: "प्रदर्शन",
      geneticWorth: "आनुवंशिक मूल्य",
      healthRecord: "स्वास्थ्य अभिलेख",
      genotypeData: "जीनोटाइप डाटा",
      reminders: "रिमाइन्डरहरू",
      activityLog: "गतिविधि लग",
      activityLogDetails: "गतिविधि लग विवरण",
      editAnimal: "पशु सम्पादन गर्नुहोस्",
      familyInfo: "पारिवारिक जानकारी",
      breedInfo: "नस्ल जानकारी",
      identification: "परिचय",
      removalInfo: "हटाउने जानकारी",
      iDOfAnimalDam: "जनावरको बाँधको आईडी।",
      iDOfAnimalSire: "जनावरको सरको आईडी।",
      iDOfDamEmbryoUsed: "बाँधको आईडी जसको भ्रूण प्रयोग गरिएको थियो।",
      animalHasATwinOrNot: "जनावरमा जुम्ल्याहा छ कि छैन।",
      breedType: "नस्ल प्रकार",
      breedOfTheAnimal: "यो जनावरको एक जात हो।",
      regBreedAssociations: "नस्ल संघ / समाज संग दर्ता।",
      nameOfAssociationsSocieties: "पशु दर्ता भएको संघ/समाजको नाम।",
      nameOfTheOrgSuppliedAnimal: "यो पशु आपूर्ति गर्ने संस्थाको नाम हो।",
      countryOriginAnimal: "जनावरको उत्पत्तिको देश।",
      birthFarmID: "जन्म फार्म आईडी",
      farmIDAnimalBorn: "जनावरको जन्म भएको फार्म ID।",
      currentOwner: "हालको मालिक",
      nameOfOwnerAnimal: "यो जनावरको मालिकको नाम हो।",
      registrationDate: "दर्ता मिति",
      previousOwner: "अघिल्लो मालिक",
      nameOfOperator: "अपरेटरको नाम",
      dateAnimalRemoved: "जनावर हटाउने मिति।",
      destinationPlaceRemovedAnimal: "हटाइएका जनावरहरूको लागि गन्तव्य स्थान",
      namePersonFillAnimalInformation: "यो जनावरको जानकारी भर्ने व्यक्तिको नाम।",
      reasonOfAnimalRemoval: "जनावर हटाउने कारण",
      reasonWhyTheAnimalIsRemoved: "कारण किन जनावर हटाइयो",
      processingDate: "प्रशोधन मिति",
      DateInformationFilledChanged: "हालको जानकारी भरिएको वा परिवर्तन भएको मिति।",
      animalID: "पशु आईडी",
      UniqueIdAnimal: "यो जनावरको अद्वितीय आईडी हो।",
      plasticTagNumber: "प्लास्टिक ट्याग नम्बर",
      numberAnimalTag: "पशु ट्यागको संख्या।",
      rFTagNumber: "RF ट्याग नम्बर",
      numberAnimalRFTag: "पशु RF ट्यागको संख्या।",
      govtRegNumb: "सरकार ",
      govtRegistrationNumber: "पहिचान विवरणहरू जसमा व्यक्तिको नाम र ठेगाना, प्रक्रियाको सेवाको लागि व्यक्तिको एजेन्ट, प्रदर्शन गरिने गतिविधिको स्थान, र व्यक्तिले प्रदान गर्ने सेवाको विवरण समावेश हुन सक्छ।",
      numberAssignedAnimalIsRemoved: "ट्र्याकिङ नम्बर पशु गतिविधि ट्र्याक गर्न प्रयोग गरिने जनावरहरूको आईडी मध्ये एक हो।",
      dateOfAnimalRegistration: "पशु दर्ताको मिति",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "ब्रान्ड - केवल स्थायी चिन्ह जुन गाईमा जलाइएको थियो।",
      tattoOnAnimal: "जनावर मा ट्याटू।",
      whetherTheAnimalIsDehorned: "जनावरलाई निर्दोष छ कि छैन।",
      milkingAnimals: "दूध दिने जनावरहरू",
      studAnimals: "स्टड जनावरहरू",
      animalInseminationRecord: "पशु गर्भाधान रेकर्ड",
      numOfStrawsOrdered: "अर्डर गरिएका परालहरूको संख्या",
      totalNumOfStraws: "परालहरूको कुल संख्या",
      strawId: "स्ट्रा आईडी",
      addSireAutomation: "Sire Automation थप्नुहोस्",
      addApprovalAutomation: "अनुमोदन स्वचालन थप्नुहोस्",
      addCollectionAutomation: "सङ्कलन स्वचालन थप्नुहोस्",
      addStrawsAutomation: "स्ट्रास स्वचालन थप्नुहोस्",
      addPackAutomation: "प्याक स्वचालन थप्नुहोस्",
      addPostageAutomation: "हुलाक स्वचालन थप्नुहोस्",
      searchBySire: "Sire द्वारा खोज्नुहोस्",
      numberOfProgenies: "सन्तान संख्या",
      sireEdit: "सर सम्पादन गर्नुहोस्",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "स्ट्रा आईडी, स्ट्राको कुल संख्या, ब्याच नम्बर र स्थान आईडी द्वारा खोज्नुहोस्",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "प्याक आईडी द्वारा खोज्नुहोस्, स्ट्राको संख्या अर्डर गर्नुहोस्, प्याकिंग टेक्निसिया",
      searchByCollectionAndPreparationTechnicia: "सङ्कलन र तयारी प्राविधिक द्वारा खोज",
      registerSemenAutomation: "वीर्य स्वचालन दर्ता गर्नुहोस्",
      addSemenAutomation: "वीर्य स्वचालन थप्नुहोस्",
      strawAutomationRegistered: "स्ट्र स्वचालन दर्ता",
      strawAutomationRegisteredNotRegistered: "स्ट्र स्वचालन दर्ता गरिएको छैन",
      sireAutomationRegistered: "सर स्वचालन दर्ता",
      sireAutomationNotRegistered: "सर स्वचालन दर्ता गरिएको छैन",
      postageAutomationIsRegistered: "हुलाक स्वचालन दर्ता गरिएको छ",
      postageAutomationNotRegistered: "हुलाक स्वचालन दर्ता गरिएको छैन",
      packAutomationIsRegistered: "प्याक स्वचालन दर्ता गरिएको छ",
      packAutomationNotRegistered: "प्याक स्वचालन दर्ता गरिएको छैन",
      postageAutomationIsUpdated: "हुलाक स्वचालन अद्यावधिक गरिएको छ",
      postageAutomationNotUpdated: "हुलाक स्वचालन अद्यावधिक गरिएको छैन",
      packAutomationIsUpadted: "प्याक स्वचालन अपडेट गरिएको छ",
      packAutomationNotUpadted: "प्याक स्वचालन अपडेट गरिएको छैन",
      collectionAutomationUpdated: "संग्रह स्वचालन अपडेट गरियो",
      collectionAutomationNotUpdated: "सङ्कलन स्वचालन अद्यावधिक गरिएको छैन",
      approvalAutomationIsUpdated: "अनुमोदन स्वचालन अद्यावधिक गरिएको छ",
      approvalAutomationIsNotUpdated: "अनुमोदन स्वचालन अद्यावधिक गरिएको छैन",
      collectionAutomationRegistered: "सङ्कलन स्वचालन दर्ता",
      collectionAutomationNotRegistered: "सङ्कलन स्वचालन दर्ता गरिएको छैन",
      approvalAutomationIsRegistered: "स्वीकृति स्वचालन दर्ता गरिएको छ",
      approvalAutomationIsNotRegistered: "स्वीकृति स्वचालन दर्ता गरिएको छैन",
      strawAutomationUpdated: "स्ट्र स्वचालन अपडेट गरियो",
      strawAutomationIsNotUpdated: "स्ट्र स्वचालन अद्यावधिक गरिएको छैन",
      searchSire: "सर खोज्नुहोस्",
      strawsEdit: "स्ट्राहरू सम्पादन गर्नुहोस्",
      nextAnimals: "अर्को जनावर",
      performanceInfo: {
        milk: "दूध",
        liveweight: "लाइभवेट",
        score: "स्कोर",
        fertility: "प्रजनन क्षमता",
        measurements: "मापन",
        dailyProteinYield: "दैनिक प्रोटिन उपज",
        amountProteinMilkCowDay: "विशेष दिनमा गाईबाट प्राप्त दूधमा प्रोटिनको मात्रा।",
        dailyMilkYield: "दैनिक दूध उत्पादन",
        volumeMilkCowDay: "एक विशेष दिनमा एक विशेष गाई बाट प्राप्त दूध को मात्रा।",
        dailyFatYield: "दैनिक बोसो उपज",
        amountFatMilkCowDay: "विशेष दिनमा गाईबाट प्राप्त दूधमा बोसोको मात्रा।",
        dailyProteinContent: "दैनिक प्रोटीन सामग्री",
        dailyFatContent: "दैनिक बोसो सामग्री",
        milkLactose: "दूध ल्याक्टोज",
        amountLactoseMilk: "दूधमा ल्याक्टोजको मात्रा।",
        milkUrea: "दूध यूरिया",
        indicatorAmountCrudeProtein: "गाईको आहारमा कच्चा प्रोटिनको मात्राको सूचक",
        lactationNumber: "स्तनपान संख्या",
        ordinalNumLactation: "दुध खुवाउने क्रम संख्या।",
        lengthOfLactation: "स्तनपानको लम्बाइ (जस्तै 23 दिन)",
        lactationLength: "स्तनपान लम्बाइ",
        milkingFrequency: "दूध पिउने आवृत्ति",
        frequcnyOfMilking: "दूध निकाल्ने आवृत्ति (जस्तै प्रति दिन २ पटक)",
        liveWeightInformation: "लाइभवेट जानकारी",
        currentWeight: "वर्तमान वजन",
        weightAnimal: "जनावरको वजन।",
        postWeaningGain: "दूध छुटाउने पछिको लाभ",
        dailyGainInAnimalWeightWeaning: "दूध छाडेपछि जनावरको तौलमा दैनिक वृद्धि।",
        weaningWeight: "वजन घटाउने",
        weightAnimalMeasuredWeaning: "दूध छुटाउने दिनमा पशुको तौल नापिन्छ।",
        averageDailyGain: "औसत दैनिक लाभ",
        averageAmountWeightAnimalGainFeedingPeriod: "खाना खुवाउने अवधिमा जनावरले हरेक दिन बढेको तौलको औसत मात्रा",
        carcassWeight: "शवको वजन",
        weightAnimalsHideInternalOrgansRemoved: "टाउको, छाला र भित्री अंगहरू हटाएपछि जनावरहरूको वजन।",
        weightAtCalving: "बाछिलो मा वजन",
        weightAtTheTimeOfCalving: "बाल्ने समयमा वजन।",
        yearlingWeight: "वार्षिक वजन",
        weightYearOldAnimal: "एक वर्ष पुरानो जनावरको वजन।",
        somaticCellScore: "सोमाटिक सेल स्कोर",
        somaticCellScoreIndicatorMastitis: "मास्टिटिसको लागि सूचकको रूपमा सोमाटिक सेल स्कोर। ",
        lastUpdate: "अन्तिम अपडेट",
        bodyConditionScore: "शारीरिक अवस्था स्कोर",
        scoreAnimalFat: "कति बोसो छ भन्ने सम्बन्धमा जनावरको स्कोर।  ",
        teatScore: "टिट स्कोर",
        scoreMeasureingShapeTeats: "टिट साइज स्कोरहरू टिट लम्बाइ र परिधि र 9 (धेरै सानो) देखि 1 (धेरै ठूलो) को दायराको व्यक्तिपरक मूल्याङ्कन हुन्। ",
        udderScore: "Udder निलम्बन स्कोर",
        scoreMeasureingShapeOfUdder: "थनको आकार नाप्ने स्कोर (१-९ स्कोर)। ",
        whetherAnimalEasyBirthDifficult: "पशुधनमा जन्मनु एक प्राकृतिक प्रक्रिया हो तर कहिलेकाहीं त्यहाँ जन्म समस्याहरू हुन सक्छ जहाँ बाँधलाई किसान / पशुपालकको सहयोग चाहिन्छ।",
        totalLongevity: "कुल दीर्घायु",
        survivalLactationTraitCowCulledBreeding: "1 देखि 5 औं स्तनपान सम्म बाँच्न। ",
        docility: "नम्रता",
        circumferenceBullScrotal: "गोरुको अण्डकोषको परिधि",
        intervalSuccessInsemination: "पहिलो देखि सफल गर्भाधान सम्म अन्तराल।",
        ageAtFirstCalving: "पहिलो बौछारमा उमेर",
        ageCowCalving: "पहिलो बाछोमा गाईको उमेर कति हुन्छ ।",
        calvingInterval: "Calving अन्तराल",
        periodCalving: "एउटा बाछो देखि अर्को बाछो सम्मको अवधि।",
        scrotalCircumference: "स्क्रोटल परिधि",
        estrusDetection: "एस्ट्रस पत्ता लगाउने",
        trackingBehaviorAnimalDetectingEstrus: "गाईको एस्ट्रस पत्ता लगाउनको लागि जनावरको चाल व्यवहार ट्र्याक गर्दै।",
        presenceOfEstrus: "Estrus को उपस्थिति",
        isCowInEstrusStage: "जब गाई एस्ट्रस स्टेजमा हुन्छ वा न त",
        matureWeight: "परिपक्व वजन",
        weightAnimalDefinedAge: "एक परिभाषित उमेर मा एक जनावर को वजन।",
        matureHeight: "परिपक्व उचाइ",
        heightAnimalDefinedAge: "निर्धारित उमेरमा जनावरको उचाइ।",
        footClawSet: "खुट्टा पंजा सेट",
        shapeAnimalClaw: "जनावरको पंजाको आकार।",
        pulmonaryArterialPressure: "फुफ्फुसीय धमनी दबाव",
        animalBloodPreasure: "जनावरको रगत प्रीजर।",
        footAngle: "फुट कोण",
        shapeAnimalFoot: "जनावरको खुट्टाको आकार।",
        ribEyeArea: "रिब-आँखा क्षेत्र",
        amountRibEyeArea: "रिब-आँखा क्षेत्र को मात्रा।",
        ultrasoundFat: "अल्ट्रासाउन्ड फ्याट",
        measureFatAmount: "बोसो को मात्रा मापन।",
        ultrasoundIntramuscularFat: "अल्ट्रासाउन्ड इन्ट्रामस्कुलर फ्याट",
        ultrasoundRibEyeArea: "अल्ट्रासाउन्ड रिब-आँखा क्षेत्र",
        measureRibeyeArea: "Ribeye क्षेत्र को मापन।",
        fatThickness: "बोसो मोटाई",
        anmountAnimalBackFat: "जनावरको पछाडिको बोसोको मात्रा।",
        marbling: "मार्बलिङ",
        marballingMeasurement: "मार्बलिङ भनेको मांसपेशी भित्र र मांसपेशी फाइबर बन्डलहरू बीच जम्मा हुने असंतृप्त (स्वस्थ) इन्ट्रामस्कुलर फ्याट हो।",
        dryMatterIntake: "सुक्खा पदार्थ सेवन",
        amountFeedAnimalConsumesAMoisture: "एक जनावरले प्रति दिन ओसिलो-रहित आधारमा खपत गर्ने दानाको मात्रा।"
      },
      feedsName: "फिडको नाम",
      feedName: "फिड नाम",
      firstFeedQuantity: "पहिलो फिड मात्रा",
      additionalFeed: "अतिरिक्त फीड",
      cloversRyeGrasses: "क्लोभर्स, राई घाँस",
      greenFodderHayLegumes: "हरियो चारा, घाँस, फलफूल",
      feedsRegisteredSuccessfully: "फिडहरू सफलतापूर्वक दर्ता गरियो",
      feedsNotRegistered: "फिडहरू दर्ता गरिएको छैन",
      fEEDQUANTITY: "फिड मात्रा",
      feedQuantity: "फिड मात्रा",
      fEEDNAME: "फीड नाम",
      nOFEEDINFOAVAILABLE: "कुनै फिड जानकारी उपलब्ध छैन",
      searchByFeedName: "फीड नाम द्वारा खोज्नुहोस्",
      loadingFeedInfo: "फिड जानकारी लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      todayFeedInfo: "आज फिड जानकारी",
      feedInfo: "फिड जानकारी",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit। ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "यो प्रजनन मूल्य आर्थिक सूचकांक को गणना को लागी प्रयोग गरिन्छ।",
        dailyProteinYieldUsed: "दैनिक प्रोटिन उपज प्रयोग",
        weightAssignedBreedingDailyProteinYield: "\"दैनिक प्रोटिन उपज\" सँग सम्बन्धित प्रजनन मानमा तोकिएको वजन।" ,
        dailyProteinYieldWeight: "दैनिक प्रोटीन उपज वजन",
        rankAnimalInRelationshipEconomicIndex: "आर्थिक सूचकांकको सम्बन्धमा जनावरको श्रेणी।",
        economicIndexRank: "आर्थिक सूचकांक श्रेणी",
        percentileEconomicIndexFall: "प्रतिशत कुन आर्थिक सूचकांकमा खस्छ।",
        economicIndexPercentile: "आर्थिक सूचकांक प्रतिशत",
        accuracyOfEconomicIndex: "आर्थिक सूचकांकको शुद्धता।",
        economicIndexAccuracy: "आर्थिक सूचकांक शुद्धता",
        weightedAverageOfBreedingValues: "प्रजनन मानहरूको भारित औसत।",
        economicIndex: "आर्थिक सूचकांक",
        rankOfAnimalInRelationshipBreeding: "सम्बन्धित प्रजनन मूल्यको सम्बन्धमा जनावरको श्रेणी।",
        dailyProteinYieldBreedingValueRank: "दैनिक प्रोटीन उपज प्रजनन मूल्य श्रेणी ",
        percentileBreedingFalls: "प्रजनन मूल्यमा पर्ने प्रतिशत।",
        dailyProteinYieldBreedingPercentile: "दैनिक प्रोटीन उपज प्रजनन मूल्य प्रतिशतक ",
        accuracyEstimatedBreeding: "अनुमानित प्रजनन मूल्यको शुद्धता।",
        dailyProteinYieldBreedingAccuracy: "दैनिक प्रोटीन उपज प्रजनन मूल्य शुद्धता",
        estimatedBreedingTraitDailyProteinYield: "विशेषताको अनुमानित प्रजनन मूल्य \"दैनिक प्रोटीन उपज।",
        dailyProteinYieldBreedingValue: "दैनिक प्रोटिन उपज प्रजनन मूल्य ",
        pathToTheDirectoryScriptsBreeding: "प्रजनन मानको गणनाको लागि प्रयोग गरिएको स्क्रिप्टहरू भएको हार्ड ड्राइभमा डाइरेक्टरीमा जाने बाटो।",
        scriptsPath: "स्क्रिप्ट पथ",
        softwarePackageBreeding: "प्रजनन मूल्य गणना गर्न प्रयोग गरिएको सफ्टवेयर प्याकेज।",
        breedingValueSoftware: "प्रजनन मूल्य सफ्टवेयर",
        methodCalculateBreeding: "प्रजनन गणना गर्न प्रयोग गरिएको विधि",
        breedingValueMethod: "प्रजनन मूल्य विधि",
        trait: "विशेषता",
        tools: "उपकरणहरू",
        geneticWorth: "आनुवंशिक मूल्य",
        dailyProteinYield: "दैनिक प्रोटिन उपज",
        breedingValue: "प्रजनन मूल्य",
        breedingValueBIFAccuracy: "प्रजनन मूल्य BIF सटीकता",
        breedingValuePercentile: "प्रजनन मूल्य प्रतिशत",
        breedingValueRank: "प्रजनन मूल्य श्रेणी",
        checkLTD: "LTD जाँच गर्नुहोस्",
        ultrasoundDiagnostic: "अल्ट्रासाउन्ड डायग्नोस्टिक",
        selectYieldUsed: "प्रयोग गरिएको उपज चयन गर्नुहोस्",
        softwareName: "सफ्टवेयर नाम",
        animalGenWorthUpdatedSuccessfully: "Animal Gen Worth सफलतापूर्वक अपडेट भयो"
      },
      addNote: "नोट थप्नुहोस्",
      enterNote: "नोट प्रविष्ट गर्नुहोस्",
      noteIsRequired: "नोट आवश्यक छ",
      noteMustBeLessThan50Characters: "नोट 50 वर्ण भन्दा कम हुनु पर्छ",
      noteAdded: "नोट थपियो",
      noteNotAdded: "नोट थपिएको छैन",
      noteForAnimal: "जनावरको लागि नोट।",
      noNoteFoundForThisAnimal: "यस जनावरको लागि कुनै नोट फेला परेन।",
      inseminationData: "गर्भाधान डाटा",
      nameOfInseminator: "इन्सेमिनेटरको नाम",
      activity: "गतिविधि",
      searchByNameActivity: "नाम, गतिविधि द्वारा खोज",
      searchByTaskNameNumber: "कार्य नाम, नम्बर द्वारा खोज्नुहोस्",
      inseminationDate: "गर्भाधान मिति",
      genotypeDataInfo: {
        genotypeAnimalID: "जीनोटाइप पशु आईडी",
        iDTubeBloodSampleAnimalNumberGenotypingService: "यो जनावरबाट लिइएको रगतको नमूना वा जीनोटाइपिङ सेवाको संख्या भएको ट्यूबको आईडी हो",
        geneticTechnicianName: "आनुवंशिक प्राविधिक नाम",
        NameTechnicianBloodSamplesAnimal: "यो जनावरको रगतको नमूना लिने प्राविधिकको नाम हो",
        sNPData: "SNP डाटा",
        genotypingServiceNote: "जीनोटाइपिङ सेवा नोट",
        InfoGenotypingGenotypingTechnology: "जीनोटाइपिङसँग सम्बन्धित सबै जानकारीहरू जस्तै जीनोटाइपिङ कम्पनीको नाम, प्रयोग गरिएको जीनोटाइपिङ प्रविधि, जीनोटाइपिङको मिति, आदि।",
        numberOfSNPs: "SNP को संख्या",
        numberOfSNPsAnimalGenotyped: "जनावरको लागि जीनोटाइप गरिएको SNP को संख्या",
        nameOfTheDrug: "औषधिको नाम",
        animalGenoDataUpdatedSuccessfully: "पशु जेनो डाटा सफलतापूर्वक अद्यावधिक गरियो",
        animalGenoDataNotUpdated: "पशु जेनो डाटा अपडेट गरिएको छैन",
        animalIDIsRequired: "पशु आईडी आवश्यक छ",
        techNameIsRequired: "प्राविधिक। ",
        onlyAlphabetsAreAllowed: "केवल वर्णमालाहरूलाई अनुमति छ",
        genoDataIsRequired: "जेनो डाटा आवश्यक छ",
        serviceNoteIsRequired: "सेवा नोट आवश्यक छ",
        sNPIsRequired: "SNP आवश्यक छ"
      },
      healthRecordInfo: {
        treatment: "उपचार",
        treatmentTakenAnimal: "जनावरमा कस्तो उपचार गरियो।",
        reasonOfTreatment: "उपचार को कारण",
        reasonForTreatment: "उपचार को कारण",
        whatReasonOfTreatment: "उपचारको कारण के हो।",
        treatmentDate: "उपचार मिति",
        dateOfTreatment: "उपचारको मिति।",
        diagnosis: "निदान",
        nameDiagnosedDiseaseConditionSymptoms: "निदान गरिएको रोग/अवस्था वा मुख्य लक्षणहरूको नाम",
        drugID: "औषधि आईडी",
        iDOfDrugWhichIsGivenToAnimal: "पशुलाई दिइने औषधिको परिचयपत्र।",
        drugName: "औषधिको नाम",
        nameDrugAnimal: "जनावरलाई दिइने औषधिको नाम।",
        drugWithdrawalPeriod: "औषधि निकासी अवधि",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "मानिसको उपभोगको लागि मासु वा दूधको सुरक्षा सुनिश्चित गर्न जनावरलाई औषधि दिएपछि लाग्ने समय",
        attendingVeterinarian: "पशुचिकित्सक उपस्थित",
        qualifiedPersonCaseAnimal: "योग्य व्यक्ति जसले केस / जनावर देख्यो",
        packID: "प्याक आईडी",
        iDPackTreatment: "उपचारको लागि प्रयोग गरिएको प्याकको आईडी",
        veterinarianName: "पशु चिकित्सक नाम",
        animalNoHealthRecord: "यो जनावरको कुनै पनि स्वास्थ्य रेकर्ड छैन। ",
        addHealthRecord: "स्वास्थ्य रेकर्ड थप्नुहोस्",
        healthStatus: "स्वास्थ्य स्थिति",
        loadingDiseasesPleaseWait: "लोड हुँदैछ रोगहरू... कृपया प्रतीक्षा गर्नुहोस्",
        animalDiseaseRecord: "पशु रोग रेकर्ड",
        animalHealthRecord: "पशु स्वास्थ्य अभिलेख",
        animalTreatmentRecord: "पशु उपचार रेकर्ड",
        loadingHealthData: "स्वास्थ्य डेटा लोड गर्दै...",
        healthRecord: "स्वास्थ्य अभिलेख",
        nameOfDiagnosis: "निदान को नाम",
        treatmentName: "उपचारको नाम",
        drugGivenBy: "औषधि दिए",
        recessiveDiseases: "रिसेसिभ रोगहरू",
        recessiveDiseasesMessage: "यो साँढे कुन रिसेसिभ रोग एलिल को वाहक हो"
      },
      conceptionInfo: {
        addNewConception: "नयाँ अवधारणा थप्नुहोस्",
        semenEmbryo: "वीर्य/भ्रूण",
        pregnancyCheck: "गर्भावस्था जाँच",
        birthInfo: "जन्म जानकारी",
        searchByInseminatorOrganisationBreedingConception: "इन्सेमिनेटरको नाम, संस्थाको नाम, प्रजनन सेवा नम्बर, अवधारणा विधिद्वारा खोज्नुहोस्",
        deliveryDate: "वितरण दिन",
        calfId: "बाछोको आईडी",
        birthDayOldWeight: "जन्म (दिन पुरानो) वजन",
        searchByBirthEase: "जन्म सहजता द्वारा खोज",
        searchPregnancyCheckOperatorMethod: "गर्भावस्था जाँच अपरेटर द्वारा खोज, गर्भावस्था जाँच विधि",
        pregnancyCheckDate: "गर्भावस्था जाँच मिति",
        conceptionSuccess: "अवधारणा सफलता",
        pregnancyCheckOperator: "गर्भावस्था जाँच अपरेटर",
        pregnancyCheckMethod: "गर्भावस्था जाँच विधि",
        recentlyPregnant: "भर्खरै गर्भवती",
        pregnancyConfirmationDate: "गर्भावस्था पुष्टि मिति",
        pregnancyRate: "गर्भावस्था दर",
        timePeriodOfPregnancy: "गर्भावस्था को समय अवधि",
        semenProduction: "वीर्य उत्पादन",
        embryoProduction: "भ्रूण उत्पादन",
        semen: "वीर्य",
        embryoTransferDate: "भ्रूण स्थानान्तरण मिति",
        daysOfPregnancy: "गर्भावस्थाका दिनहरू",
        searchSireEmbryoSurrogate: "Sire id, Embryo org नाम, Surrogate dam नस्ल द्वारा खोज्नुहोस्",
        selectDate: "मिति चयन गर्नुहोस्",
        orgnisationNameContainNumber: "संस्थाको नाममा नम्बर हुनु हुँदैन",
        selectBirthEase: "जन्म सहजता चयन गर्नुहोस्",
        selectUnit: "कृपया एक एकाइ चयन गर्नुहोस्",
        animalConceptionAddedSuccessfully: "पशु अवधारणा सफलतापूर्वक थपियो",
        postageCustomerName: "हुलाक ग्राहक नाम",
        searchByPostageCustNameCustAddPostId: "हुलाक ग्राहकको नाम, ग्राहक ठेगाना, पोस्ट आईडी द्वारा खोज्नुहोस्",
        dateOfSemenCollection: "वीर्य सङ्कलन को मिति",
        dateOfSemenPreparation: "वीर्य तयारी को मिति",
        semenMotility: "वीर्य गतिशीलता",
        semenConcentration: "वीर्य एकाग्रता",
        postageEdit: "हुलाक सम्पादन",
        enterSireId: "Sire ID प्रविष्ट गर्नुहोस्",
        selectEmbryoOrganisation: "भ्रूण संगठन चयन गर्नुहोस्",
        matingDateH: "गर्भाधानको मिति, या त प्राकृतिक संभोग वा कृत्रिम गर्भाधान।",
        inseminatorNameH: "गर्भाधान प्रक्रिया गर्ने व्यक्ति (पशु चिकित्सक/प्राविधिक)",
        orgNameH: "AI को लागि वीर्य पराल प्रदान गर्ने संस्था वा कम्पनीको नाम",
        brServiceNumH: "प्रजनन संख्या रेकर्ड गर्दै (जस्तै 1st, 2nd, वा 3rd)",
        conceptionMethodH: "जनावरले गर्भधारण गर्ने तरिका जुन गर्भावस्थाको सुरुवात हो, शुक्राणुद्वारा अण्डाको निषेचनद्वारा चिन्हित।",
        sireIdH: "जनावरको पुरुष अभिभावक/बुवाको आईडी",
        damIdH: "महिला अभिभावक/पशुको आमाको आईडी।",
        sarogatedDamH: "पोथी गाईको आईडी जसमा दाता नर र दाता महिलाबाट निषेचित अण्डा यसको थप विकासको लागि प्रत्यारोपण गरिन्छ।",
        embOrgNameH: "भ्रूणको लागि संगठनको नाम",
        sarogateDamBreedH: "सरोगेट नस्लको मिति",
        sireBreedH: "सर नस्लको प्रकार (ब्राह्मण, बोरान)",
        pregCheckDateH: "अल्ट्रासाउन्ड र रगत परीक्षणको प्रयोग गरेर गाईमा ३० दिनभित्रै गर्भ रहेको पत्ता लगाउन सकिन्छ। गाईलाई प्याल्पेशन विधि प्रयोग गरी गर्भवती भनी पहिचान गर्नका लागि गाईहरू कम्तीमा ३५-५० दिनको गर्भवती हुनुपर्छ। ",
        conceptionSuccessH: " गाईवस्तुमा, निषेचन दर लगभग 55% को औसत बाछो दर संग 90% हो, लगभग 35% को भ्रूण-भ्रूण मृत्यु दर को संकेत गर्दछ (Diskin et al।, 2006)। ",
        pregnancyCheckOperatorH: "पशु चिकित्सक र विशेषज्ञ पशु प्राविधिकहरूले प्राय: किसानहरूलाई यी सेवाहरू प्रदान गर्छन्। ",
        pregnancyCheckMethodH: "गाईवस्तुको गर्भावस्था निदानका लागि प्रायः प्रयोग हुने दुईवटा विधिहरू प्रजनन पथको म्यानुअल पल्पेशन (प्रति मलद्वार) र प्रजनन पथको ट्रान्सरेक्टल अल्ट्रासोनोग्राफी हुन्।",
        deliveryDateH: "जन्म दिने मिति",
        calfIdH: "भर्खर जन्मेको बाछोको आईडी",
        birthEaseH: "पशुधनमा जन्मनु एक प्राकृतिक प्रक्रिया हो तर कहिलेकाहीं त्यहाँ जन्म समस्याहरू हुन सक्छ जहाँ बाँधलाई किसान / पशुपालकको सहयोग चाहिन्छ।",
        birthDayOldWeightH: "जन्मेको दिनमा जनावरको तौल वा एक दिन पुरानो चराको तौल",
        customerAddress: "ग्राहक ठेगाना"
      },
      all: "सबै",
      ungrouped: "समूह नगरिएका जनावरहरू",
      active: "समूहबद्ध जनावरहरू",
      updateAnimal: "पशु अपडेट गर्नुहोस्"
    },
    dashboardS: {
      dailyActivities: "दैनिक क्रियाकलाप",
      pendingTasks: "विचाराधीन कार्यहरू",
      performanceOfGeno: "जीनोटाइप को प्रदर्शन",
      breed: "नस्ल",
      chromosome: "क्रोमोजोम",
      seqChange: "अनुक्रम परिवर्तन",
      inheritance: "विरासत",
      diseaseName: "रोगको नाम",
      refSequence: "सन्दर्भ अनुक्रम",
      pubmedRef: "प्रकाशित सन्दर्भ",
      matingDate: "मिलन मिति",
      inseminatorName: "इन्सेमिनेटर नाम",
      orgName: "संस्थाकाे नाम",
      brServiceNum: "प्रजनन सेवा नम्बर",
      conceptionMethod: "अवधारणा विधि",
      semEmbInfo: "वीर्य/भ्रूण जानकारी",
      sireId: "सर आईडी",
      damID: "बाँध आईडी",
      srgDamId: "सरोगेट बाँध आईडी",
      embOrgName: "भ्रूण संगठन। ",
      srgDamBreed: "सरोगेट बाँध नस्ल",
      sireBreed: "सर नस्ल",
      damBreed: "बाँध नस्ल"
    },
    user: {
      selectLanguage: "भाषा छनोट गर्नुस",
      unitPreference: "एकाइ प्राथमिकता",
      selectUnitOfMeasure: "मापनको एकाइ चयन गर्नुहोस्",
      importedUser: "आयातित प्रयोगकर्ता",
      impFileStatus: "फाइल स्थिति आयात गर्नुहोस्",
      loadingUser: "प्रयोगकर्ताहरू लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      totalUsers: "कुल प्रयोगकर्ताहरू",
      pendingUsers: "विचाराधीन प्रयोगकर्ताहरू",
      changePassword: "पासवर्ड परिवर्तन गर्नुहोस्",
      goodIdeaToUsePassword: "तपाईंले अन्यत्र प्रयोग नगरेको बलियो पासवर्ड प्रयोग गर्नु राम्रो विचार हो।",
      enterCurrentPassword: "हालको पासवर्ड प्रविष्ट गर्नुहोस्",
      enterNewPassword: "नयाँ पासवर्ड प्रविष्ट गर्नुहोस्",
      reEnterPassword: "नयाँ पासवर्ड पुन: प्रविष्ट गर्नुहोस्",
      enterPassword: "पासवर्ड प्रविष्ट गर्नुहोस्",
      repeatNewPassword: "नयाँ पासवर्ड दोहोर्याउनुहोस्",
      emailAddr: "इ - मेल ठेगाना",
      enterYourPhoneNumber: "आफ्नो फोन नम्बर प्रविष्ट गर्नुहोस्",
      pleaseTypeOldPassword: "कृपया पुरानो पासवर्ड टाइप गर्नुहोस्।",
      pleaseTypeNewPassword: "कृपया नयाँ पासवर्ड टाइप गर्नुहोस्।",
      pleaseTypeConfirmPassword: "कृपया पुष्टि पासवर्ड टाइप गर्नुहोस्।",
      passwordChangedSuccesFully: "पासवर्ड सफलतापूर्वक परिवर्तन भयो",
      currentPassword: "वर्तमान पासवर्ड",
      newPassword: "नया पासवर्ड",
      passwordDoesNotMatch: "पासवर्डहरू मेल खाँदैन।",
      emailCanNotBeEmpty: "इमेल खाली हुन सक्दैन",
      profileUpdated: "प्रोफाइल अपडेट गरियो",
      profileNotUpdated: "प्रोफाइल अपडेट गरिएको छैन",
      unableToVerifyEmail: "इमेल प्रमाणित गर्न असमर्थ",
      otpSentOnEmail: "OTP इमेलमा पठाइयो",
      otpSentSuccessFully: "OTP सफलतापूर्वक पठाइयो",
      importUsers: "प्रयोगकर्ताहरू आयात गर्नुहोस्",
      imageUpdated: "छवि अद्यावधिक गरियो",
      departmentName: "विभागको नाम",
      departmentNum: "विभाग नम्बर",
      departmentAdded: "विभाग थपियो",
      departmentNotAdded: "विभाग थपिएको छैन",
      searchDepartnment: "विभागको नाम वा नम्बर द्वारा खोज्नुहोस्",
      addDepartMent: "विभाग थप्नुहोस्",
      addDepartment: "विभाग थप्नुहोस्",
      roleNameIsRequired: "भूमिकाको नाम आवश्यक छ",
      roleNameMustBeLessThan15Chars: "भूमिकाको नाम 15 वर्ण भन्दा कम हुनु पर्छ",
      roleAdded: "भूमिका थपियो",
      editDepartment: "विभाग सम्पादन गर्नुहोस्",
      departmentUpdated: "विभाग अद्यावधिक गरियो",
      departmentNotUpdated: "विभाग अद्यावधिक गरिएको छैन",
      deleteDepartment: "विभाग हटाउनुहोस्",
      deleteDepartmentMessage: "के तपाइँ यो विभाग मेटाउन निश्चित हुनुहुन्छ।",
      noRoleAvailable: "कुनै भूमिका उपलब्ध छैन",
      roleUpdated: "भूमिका अद्यावधिक गरियो",
      roleNotUpdated: "भूमिका अद्यावधिक गरिएको छैन",
      editRole: "भूमिका सम्पादन गर्नुहोस्",
      allRole: "सबै भूमिका",
      addNewRole: "नयाँ भूमिका थप्नुहोस्",
      allDepartment: "सबै विभाग",
      permissionsUpdated: "अनुमतिहरू अद्यावधिक गरियो",
      permissionsnotUpdated: "अनुमतिहरू अद्यावधिक गरिएको छैन",
      roleNo: "भूमिका नं.",
      searchByEmailAndName: "इमेल र नाम द्वारा खोज्नुहोस्",
      userID: "प्रयोगकर्ता ID",
      userUpdated: "प्रयोगकर्ता अपडेट गरियो",
      userNotUpdated: "प्रयोगकर्ता अपडेट गरिएको छैन",
      userAdded: "प्रयोगकर्ता थपियो",
      userNotAdded: "प्रयोगकर्ता थपिएको छैन",
      activateUser: "प्रयोगकर्ता सक्रिय गर्नुहोस्",
      deactivateUser: "प्रयोगकर्ता निष्क्रिय गर्नुहोस्",
      userStatusMsg: "के तपाइँ निश्चित हुनुहुन्छ कि तपाइँ प्रयोगकर्ता स्थिति परिवर्तन गर्न चाहनुहुन्छ",
      countryRequired: "देश आवश्यक छ",
      stateRequired: "राज्य आवश्यक छ",
      cityRequired: "शहर आवश्यक छ",
      searchByRole: "भूमिका नम्बर, भूमिका नाम, विभाग द्वारा खोज",
      noModuleAvailable: "कुनै मोड्युल उपलब्ध छैन",
      searchBYModuleName: "मोड्युल नाम द्वारा खोज्नुहोस्"
    },
    farm: {
      farmID: "फार्म आईडी",
      onTheFarm: "खेतमा",
      userRoles: "प्रयोगकर्ता भूमिकाहरू",
      adduser: "प्रयोगकर्ता थप्नुहोस्",
      addAuser: "प्रयोगकर्ता थप्नुहोस्",
      uploadUsers: "प्रयोगकर्ताहरू अपलोड गर्नुहोस्",
      addNewUser: "नयाँ प्रयोगकर्ता थप्नुहोस्",
      selectDept: "विभाग छान्नुहोस्",
      selectRole: "भूमिका चयन गर्नुहोस्",
      editUser: "प्रयोगकर्ता सम्पादन गर्नुहोस्",
      totalFarms: "कुल फार्महरू",
      NoAnimalsRegisteredForthisFarm: "यस फार्मको लागि कुनै पनि जनावर दर्ता गरिएको छैन",
      farmsPerPage: "प्रति पृष्ठ फार्महरू",
      regularFarms: "नियमित फार्महरू",
      farmRegisteredProducts: "फार्म दर्ता उत्पादनहरू",
      searchByFarmNameAndId: "फार्मको नाम र आईडी द्वारा खोज्नुहोस्",
      loadingProductsPleaseWait: "उत्पादनहरू लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      farmName: "खेतको नाम",
      farmLocation: "फार्म स्थान",
      productName: "उत्पादनको नाम",
      stockStatus: "स्टक स्थिति",
      inStock: "स्टक मा",
      searchByProductName: "उत्पादन नाम द्वारा खोज",
      productCategory: "उत्पादन कोटि",
      products: "उत्पादनहरू",
      farms: "खेतहरू",
      registerAfarm: "फार्म दर्ता गर्नुहोस्",
      govtRegistry: "सरकार ",
      cooperativeID: "सहकारी आईडी",
      farmType: "फार्म प्रकार",
      contractMating: "अनुबंध मिलन",
      customization: "अनुकूलन",
      recordsPerpage: "प्रति पृष्ठ रेकर्डहरू",
      restoreDefault: "पूर्वनिर्धारित पुनर्स्थापना",
      apply: "निवेदन गर्नु",
      searchState: "फार्म आईडी, गभर्नर रजिस्ट्री, सहकारी आईडी, फार्म प्रकार, अनुबंध मिलन द्वारा खोज्नुहोस्",
      farmOwner: "खेत मालिक",
      govRegistrationNo: "सरकारी दर्ता नम्बर",
      farmInformation: "फार्म जानकारी",
      ownershipType: "स्वामित्वको प्रकार",
      communityName: "समुदायको नाम",
      farmLicenseInformation: "फार्म लाइसेन्स जानकारी",
      licenseNumber: "लाइसेन्स नम्बर",
      licenseExpiryDate: "इजाजतपत्र समाप्ति मिति",
      regulatorName: "नियामक नाम",
      regulatorRepresentativeName: "नियामक प्रतिनिधि नाम",
      farmLocationSize: "फार्म स्थान",
      productionSystem: "उत्पादन प्रणाली",
      country: "देश",
      state: "राज्य",
      city: "सहर",
      street: "सडक",
      houseNumber: "घर नम्बर",
      farmRegistration: "फार्म दर्ता",
      cancel: "रद्द गर्नुहोस्",
      register: "दर्ता गर्नुहोस्",
      ok: "ठिक छ",
      totalFarmSize: "कुल फार्म आकार",
      farmGeographicLocation: "खेत भौगोलिक स्थान",
      perimeterPointLongitude: "परिधि बिन्दु देशान्तर",
      perimeterPointLatitude: "परिधि बिन्दु अक्षांश",
      perimeterPointLabel: "परिधि बिन्दु लेबल",
      perimeterLength: "परिधि लम्बाइ",
      farmLatitude: "फार्म अक्षांश",
      farmLongitude: "खेत देशान्तर",
      editFarm: "खेत सम्पादन गर्नुहोस्",
      update: "अपडेट गर्नुहोस्",
      editAfarm: "खेत सम्पादन गर्नुहोस्",
      nextFarm: "अर्को खेत",
      nameoftheFarm: "फार्मको नाम",
      registerAProduct: " उत्पादन दर्ता गर्नुहोस्",
      farmProducts: "कृषि उत्पादनहरू",
      calf: "बाछो",
      steer: "स्टेयर",
      heifer: "हेफर",
      sire: "हजुर",
      dam: "बाँध",
      registerAnAnimal: "एक जनावर दर्ता गर्नुहोस्",
      farmAnimals: "फार्म पशुहरू",
      farm_type: "फार्म-प्रकार",
      farm_Owner: "खेत-मालिक",
      dateOfRegistration: "दर्ता मिति",
      dataIsNotAvailableForThisFarm: "यस फार्मको लागि डाटा उपलब्ध छैन",
      registerNewProduct: "नयाँ उत्पादन दर्ता गर्नुहोस्",
      information: "जानकारी",
      licenseInfo: "लाइसेन्स जानकारी",
      locationInfo: "स्थान जानकारी",
      geoLocation: "भौगोलिक स्थान",
      perimeterLengthState: "खेत परिधिको लम्बाइ (बार लम्बाइ)",
      totalFarmSizeState: "फार्म को आकार",
      productionSystemState: "खेतमा प्रयोग हुने उत्पादन प्रणाली",
      contractMatingState: "ठेक्का मिलाउने कार्यक्रमको कोड जसमा फार्मले भाग लिन्छ।",
      ownershipTypeState: "स्वामित्वको प्रकार",
      regulatorRepresentativeNameState: "इजाजतपत्र जारी गर्ने नियामकको प्रतिनिधित्व गर्ने व्यक्तिको नाम",
      regulatorNameState: "इजाजतपत्र जारी गर्ने नियामकको नाम",
      licenseExpiryDateState: "हालको इजाजतपत्रको म्याद सकिएको मिति",
      licenseNumberState: "नियामकले जारी गरेको इजाजतपत्र नम्बर",
      plotNumberState: "खेतको घर नम्बर।",
      plotNumber: "घर/प्लट नम्बर",
      streetStatement: "फार्मको सडकको नाम।",
      cityStatement: "सहर जहाँ फार्म अवस्थित छ।",
      stateStatement: "देशको क्षेत्र जहाँ फार्म अवस्थित छ।",
      countryState: "देश जहाँ फार्म अवस्थित छ।",
      perimeterPointLongitudeState: "खेतमा एक बिन्दुको देशान्तर।",
      perimeterPointLatitudeState: "खेतमा एक बिन्दुको अक्षांश।",
      perimeterPointLabelState: "बिन्दुको लेबल।",
      farmLongitudeState: "खेत को देशान्तर।",
      farmLatitudeState: "खेतको अक्षांश।",
      farmNameH: "खेतको नाम",
      farmTypeH: "खेतको प्रकार जहाँ विभिन्न गतिविधिहरू गरिन्छ।",
      farmOwnerH: "फार्मको मालिकको नाम (स्वत: उत्पन्न किसानको नाम प्रविष्टि जानकारी)",
      ownershipTypeH: "आफूले खेती गरेको जमिनको स्वामित्व/नियन्त्रण गर्ने र नगर्ने किसानहरूको प्रकार।",
      govtRegNumbH: "नियामकले तोकेको फार्मको रजिस्ट्री नम्बर",
      contractMatingH: "ठेक्का मिलाउने कार्यक्रमको कोड जसमा फार्मले भाग लिन्छ",
      productionSystemH: "खेतमा कुन उत्पादन प्रणाली प्रयोग गरिन्छ",
      cooperativeIDH: "फार्म सदस्य भएको सहकारीको परिचयपत्र ",
      licenseNumberH: "नियामकद्वारा जारी गरिएको इजाजतपत्रमा पहिचान नम्बर जसले मालिकसँग पहिचान गर्दछ।",
      licenseExpiryDateH: "हालको इजाजतपत्रको म्याद सकिएको मिति",
      regularNameH: "इजाजतपत्र जारी गर्ने नियामकको नाम",
      regularRepName: "इजाजतपत्र जारी गर्ने नियामकको प्रतिनिधित्व गर्ने व्यक्तिको नाम",
      countryH: "देश जहाँ फार्म अवस्थित छ।",
      stateH: "देशको क्षेत्र जहाँ फार्म अवस्थित छ।",
      cityH: "सहर जहाँ फार्म अवस्थित छ।",
      streetH: "फार्मको सडकको नाम।",
      houseNumberH: "खेतको घर नम्बर।",
      totalFarmSizeH: "खेतको आकार अहिले खेतीयोग्य जमिन हो जसलाई खेती गरिन्छ तर प्राकृतिक वनस्पति, रूख वा चरन मुनिको जमिन बाहेक।",
      farmLatitudeH: "भूमध्य रेखाको उत्तर वा दक्षिण दूरीको मापन हो। ",
      farmLongitudeH: "यसले प्राइम मेरिडियनको पूर्व वा पश्चिम दूरी नाप्छ।",
      perimeterLengthH: "खेत परिधिको लम्बाइ (बार लम्बाइ)",
      perimeterPointLabelH: "बिन्दुको लेबल। ",
      perimeterPointLatH: "खेतमा एक बिन्दुको अक्षांश",
      perimeterPointLongH: "खेतमा एक बिन्दुको देशान्तर",
      noProductAvailable: "कुनै उत्पादन उपलब्ध छैन",
      farmUpdated: "फार्म अपडेट गरियो",
      performance: "प्रदर्शन",
      milkInformation: "दूध जानकारी",
      farmNameRequired: "फार्मको नाम आवश्यक छ"
    },
    login: {
      welcome: "स्वागत छ! ",
      welInfo: "आफ्नो प्रमाणहरू प्रविष्ट गर्नुहोस्।",
      login: "लग - इन",
      forgotPassword: "पासवर्ड भुल्नु भयो",
      forgotPasswordDesc: "कृपया आफ्नो खातासँग सम्बन्धित इमेल ठेगाना प्रविष्ट गर्नुहोस्। ",
      backToLogin: "लगइन मा फर्कनुहोस्"
    },
    actionListmod: {
      actionList: "कार्य सूची",
      tODAY: "आज",
      createTask: "कार्य सिर्जना गर्नुहोस्",
      myActivities: "मेरा गतिविधिहरू",
      jhonSmith: "जोन स्मिथ",
      farmID: "फार्म आईडी",
      dateOfEvent: "घटनाको मिति",
      actionRequired: "कारबाही आवश्यक छ",
      actionTaken: "कारबाही गरियो",
      animalEventID: "पशु घटना आईडी",
      cANCEL: "रद्द गर्नुहोस्",
      cONFIRM: "पुष्टि गर्नुहोस्",
      sTATEMENT: "के तपाइँ यो रेकर्ड मेटाउन निश्चित हुनुहुन्छ?",
      dAY: "दिन",
      wEEK: "हप्ता",
      mONTH: "महिना",
      sUBMIT: "पेश गर्नुहोस्",
      startDate: "सुरू मिति",
      endDate: "अन्त्य मिति",
      rEPEAT: "दोहोर्याउनुहोस्",
      taskCategory: "कार्य श्रेणी",
      pRIORITY: "प्राथमिकता",
      aSSIGNEE: "तोकिएको व्यक्ति",
      selectLocation: "स्थान चयन गर्नुहोस्",
      selectAnimals: "एक वा धेरै जनावरहरू चयन गर्नुहोस्",
      dESCRIPTION: "विवरण",
      customRecurrence: "अनुकूलन पुनरावृत्ति",
      repeatEvery: "प्रत्येक दोहोर्याउनुहोस्",
      taskName: "कार्य नाम",
      enterDescription: "विवरण प्रविष्ट गर्नुहोस्",
      toDo: "गर्नु पर्ने",
      assignTo: "लाई तोक्नुहोस्",
      status: "स्थिति",
      nOTE: "नोट",
      noTaskAvailable: "कुनै कार्य उपलब्ध छैन",
      healthRecord: "स्वास्थ्य अभिलेख",
      iD: "ID",
      tAG: "ट्याग",
      dateOfbirth: "जन्म मिति",
      taskTakenat: "मा लिइएको कार्य",
      gENDER: "लिङ्ग",
      bREED: "नस्ल",
      regDate: "Reg. ",
      updateHealthRecord: "जनावरहरूको लागि स्वास्थ्य रेकर्ड अद्यावधिक गर्नुहोस्",
      treatment: "उपचार",
      reasonOftreatment: "उपचार को कारण",
      treatmentDate: "उपचार मिति",
      dIAGNOSIS: "निदान",
      drugId: "ड्रग आईडी",
      drugName: "औषधिको नाम",
      drugWithdrawalperiod: "औषधि निकासी अवधि",
      attendingVeterinarian: "पशुचिकित्सक उपस्थित",
      packId: "प्याक आईडी",
      noItemsselected: "कुनै वस्तु चयन गरिएको छैन",
      healthRecordsubmission: "स्वास्थ्य अभिलेख पेश गर्ने",
      inseminationRecordsubmission: "गर्भाधान - अभिलेख पेश",
      inseminatorName: "इन्सेमिनेटर नाम",
      inseminatorId: "इन्सेमिनेटर आईडी",
      conceptionRate: "गर्भाधान दर",
      dateOfmeasurement: "मापन मिति",
      recordSubmission: "रेकर्ड सबमिशन",
      uPDATE: "अपडेट गर्नुहोस्",
      updateTask: "कार्य अपडेट गर्नुहोस्"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "इन्सेमिनेटर जानकारी थप्नुहोस्",
      inseminatorNumber: "इन्सेमिनेटर नम्बर",
      loadingInseminatorPleaseWait: "इन्सेमिनेटर लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      searchByIDAndName: "आईडी र नाम द्वारा खोज्नुहोस्",
      inseminatorInfoAdded: "इन्सेमिनेटर जानकारी थपियो",
      inseminatorInfoNotAdded: "इन्सेमिनेटर जानकारी थपिएको छैन",
      inseminatorInfoUpdated: "इन्सेमिनेटर जानकारी अपडेट गरियो",
      inseminatorInfoNotUpdated: "इन्सेमिनेटर जानकारी अपडेट गरिएको छैन",
      editAInseminatorInfo: "इन्सेमिनेटर जानकारी सम्पादन गर्नुहोस्",
      inseminatorList: "इन्सेमिनेटर सूची",
      inseminatorInfoDetails: "इन्सेमिनेटर जानकारी विवरण",
      updateInseminatorInfo: "इन्सेमिनेटर जानकारी अपडेट गर्नुहोस्"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "आदेशहरू लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      addStocks: "स्टकहरू थप्नुहोस्",
      addStock: "स्टक थप्नुहोस्",
      quantity: "मात्रा",
      selectUnit: "एकाइ चयन गर्नुहोस्",
      farmProducts: "कृषि उत्पादनहरू",
      cost: "लागत",
      transactionID: "कारोबार आईडी",
      recipientID: "प्रापक आईडी",
      orderID: "अर्डर आईडी",
      recepientName: "प्रापकको नाम",
      createAOrder: "अर्डर सिर्जना गर्नुहोस्",
      totalStocks: "कुल स्टक",
      orders: "आदेश",
      totalPending: "कुल पेन्डिङ",
      totalDelivered: "कुल वितरण",
      searchByRecepientNameOrderIdRecepientId: "प्रापकको नाम, अर्डर आईडी, प्रापक आईडी द्वारा खोज्नुहोस्",
      chooseTheDate: "मिति छान्नुहोस्",
      transactionDate: "लेनदेन मिति",
      selectCategory: "श्रेणी चयन गर्नुहोस्",
      volumeOfProduct: "उत्पादन को मात्रा",
      productQuantity: "उत्पादन मात्रा",
      productRecipientId: "उत्पादन प्राप्तकर्ता आईडी",
      productRecipientName: "उत्पादन प्राप्तकर्ता नाम",
      productRecipientType: "उत्पादन प्राप्तकर्ता प्रकार",
      singleProduct: "एकल उत्पादन",
      orderPlaced: "अर्डर राखियो",
      orderNotPlaced: "अर्डर राखिएको छैन",
      totalPrice: "कुल रकम",
      currency: "मुद्रा",
      selectCurrency: "मुद्रा चयन गर्नुहोस्",
      address: "ठेगाना",
      enterAddress: "ठेगाना प्रविष्ट गर्नुहोस्",
      attachments: "संलग्नहरू",
      chooseFile: "फाइल छान्नुहोस्",
      nameOfTheFarm: "खेतको नाम",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "लोरेम इप्सम 1500 को दशकदेखि उद्योगको मानक डमी पाठ भएको छ, जब एक अज्ञात प्रिन्टरले",
      billedTo: "लाई बिल गरियो",
      orderStatus: "अर्डर स्थिति",
      selectStatus: "स्थिति चयन गर्नुहोस्",
      cadbury: "क्याडबरी",
      totalAmount: "कुल रकम",
      deliveryCharges: "डेलिभरी शुल्कहरू",
      orderDetails: "आदेश विवरण",
      deliveryOnTime: "समयमा डेलिभरी",
      productID: "उत्पादन ID",
      productRegistration: "उत्पादन दर्ता",
      enterTheNameOfTheProduct: "उत्पादनको नाम प्रविष्ट गर्नुहोस्",
      nameOfTheProduct: "उत्पादन को नाम",
      productAdded: "उत्पादन थपियो",
      productNotAdded: "उत्पादन थपिएको छैन"
    },
    drug: {
      dRUGS: "ड्रग्स",
      registerAdrug: "औषधि दर्ता गर्नुहोस्",
      sEARCH: "खोज्नुहोस्",
      genericName: "सामान्य नाम",
      manufacturer: "निर्माता",
      distributor: "वितरक",
      registrationDate: "दर्ता मिति",
      drugRegistration: "औषधि दर्ता",
      drugInformation: "औषधि जानकारी",
      packExpiration: "प्याक समाप्ति",
      drugId: "औषधि आईडी",
      drugName: "औषधिको नाम",
      drugGenericname: "ड्रग जेनेरिक नाम",
      drugManufacturer: "औषधि उत्पादक",
      distributorName: "वितरक नाम",
      drugRegistrationdate: "औषधि दर्ता मिति",
      nextDrug: "अर्को औषधि",
      editDrug: "औषधि सम्पादन गर्नुहोस्",
      updateDrug: "औषधि अपडेट गर्नुहोस्",
      deleteDrug: "औषधि मेटाउनुहोस्",
      noRecordfound: "कुनै रेकर्ड फेला परेन",
      addDrug: "औषधि थप्नुहोस्",
      statementDrug: "औषधि मेटाइएको छ।  ",
      cANCEL: "रद्द गर्नुहोस्",
      cONFIRM: "पुष्टि गर्नुहोस्",
      sTATEMENT: "के तपाइँ यो रेकर्ड मेटाउन निश्चित हुनुहुन्छ?",
      ok: " ठिक छ",
      information: "जानकारी",
      packOrder: "प्याक अर्डर",
      packPrescription: "प्याक प्रिस्क्रिप्शन",
      packReservation: "प्याक आरक्षण",
      packLocation: "प्याक स्थान",
      drugDozedam: "बाँधको लागि एक दिनमा औषधिको खुराक",
      drugDozecalf: "बाछोको लागि एक दिनमा औषधिको खुराक",
      drugFormate: "औषधि ढाँचा",
      drugDistributor: "औषधि वितरक",
      drugActiveingridents: "औषधि सक्रिय सामाग्री",
      drugSubstitutionId: "औषधि प्रतिस्थापन आईडी",
      packId: "प्याक आईडी",
      packBatchNumber: "प्याक ब्याच नम्बर",
      drugIdStatement: "औषधिको ब्याच नम्बर।",
      drugNameSatement: "विज्ञापन गरिएको ब्रान्ड नाम जस अन्तर्गत औषधि बेचिन्छ।",
      drugGenericnameStatement: "विज्ञापन गरिएको ब्रान्ड नामको सट्टा औषधिको रासायनिक मेकअप जस अन्तर्गत औषधि बेचिन्छ।",
      drugFormateSatement: "औषधिको ब्याच नम्बर।",
      drugDozecalfSatement: "बाछोलाई औषधिको खुराकको मात्रा थाहा पाउन।",
      drugDozedamStatement: "बाँधमा औषधिको खुराकको मात्रा थाहा पाउन।",
      drugManufacturerStatement: "औषधि निर्माताको विवरण।",
      drugDistributorStatement: "औषधि वितरकको विवरण।",
      drugRegistrationdateStatement: "विशिष्ट देशमा औषधि दर्ताको मिति।",
      drugActiveingridentsStatement: "सक्रिय अवयवहरूको सूची।",
      drugSubstitutionIdStatement: "मुख्य औषधि हाल उपलब्ध नभएको अवस्थामा औषधिको सम्भावित प्रतिस्थापनको आईडीहरू।",
      packIdStatement: "प्याकको बार कोड वा आरएफ आईडी।",
      packBatchNumberStatement: "निर्माताद्वारा प्याकमा तोकिएको ब्याच नम्बर।",
      locationWarehouseID: "स्थान गोदाम ID",
      locationWarehouseIDState: "गोदामको ID जहाँ प्याक भण्डारण गरिएको छ।",
      locationRackID: "स्थान र्याक आईडी",
      locationRackIDStatement: "प्याक भण्डारण गरिएको र्याकको ID।",
      locationTierID: "स्थान टियर ID",
      locationTierIDStatement: "प्याक भण्डारण गरिएको र्याकमा टियरको ID।",
      locationPositionID: "स्थान स्थिति आईडी",
      locationPositionIDStatement: "प्याक भण्डारण गरिएको टियरमा रहेको स्थितिको ID।",
      storageTemperatureCondition: "भण्डारण तापमान अवस्था",
      storageTemperatureConditionStats: "प्याक भण्डारणको अवस्था।",
      containerForm: "कन्टेनर फारम",
      containerFormStatement: "कन्टेनरको फारम जसमा औषधि प्याक गरिएको थियो।",
      consistQuantity: "मात्रा मिलाउनुहोस्",
      consistQuantityStatement: "प्याकमा चक्की, बोतल, आदि को मात्रा।",
      releaseId: "जारी आईडी",
      releaseIdStatement: "किसानले प्याक लिएपछि तोकिएको परिचयपत्र।",
      releaseDate: "रिलीज मिति",
      releaseDateStatement: "किसानले स्टकबाट प्याक लिएको मिति।",
      packManufacturedDate: "प्याक निर्माण मिति",
      packManufacturedDateStatement: "प्याक निर्माण भएको मिति।",
      packImportedDate: "प्याक आयात गरिएको मिति",
      packImportedDateStatement: "प्याक आयात भएको मिति।",
      packExpirationDate: "प्याक समाप्ति मिति",
      packExpirationDateStatement: "प्याकको म्याद सकिएको मिति।",
      expiredSoonFlag: "झण्डा चाँडै समाप्त भयो",
      expiredSoonFlagState: "प्याकको म्याद चाँडै समाप्त हुने बारे चेतावनी।",
      packTotalVolumeLeft: "प्याक कुल भोल्युम बायाँ",
      packTotalVolumeLeftState: "स्टकमा बाँकी रहेका समान सामग्री भएका प्याकहरूको कुल सङ्ख्या।",
      packOrderID: "प्याक अर्डर आईडी",
      packOrderIDState: "वितरकबाट प्याक अर्डर गरेपछि तोकिएको आईडी।",
      packQuantityOrdered: "प्याक मात्रा अर्डर गरियो",
      packQuantityOrderedState: "वितरकबाट अर्डर गरिएका प्याकहरूको संख्या।",
      packPrice: "प्याक मूल्य",
      packPriceStatement: "प्याकको मूल्य।",
      priceCurrency: "मूल्य मुद्रा",
      packPricecurrency: "प्याक मूल्य मुद्रा",
      packPricecurrencyState: "मुद्रा नाम जसमा मूल्य नामांकन गरिएको छ।",
      packPaydate: "प्याक भुक्तानी मिति",
      payDate: "भुक्तानी मिति",
      packPaydateState: "वितरकलाई भुक्तानी जारी भएको मिति।",
      packShippingID: "प्याक ढुवानी आईडी",
      shippingID: "ढुवानी आईडी",
      packShippingIdState: "प्याकको ढुवानी आईडी वितरकबाट आइपुग्दा।",
      packShippingDate: "प्याक ढुवानी मिति",
      shippingDate: "ढुवानी मिति",
      packShippingDateState: "स्टकमा प्याकको आगमन मिति।",
      packOrderStatus: "प्याक अर्डर स्थिति",
      packOrderStatusState: "हालको अर्डरको स्थिति।",
      recepientKeeperId: "प्राप्तकर्ता किपर आईडी",
      recepientKeeperIdStatement: "प्याक प्राप्त गर्ने व्यक्ति/संस्थाको नाम।",
      recepientFarmId: "प्रापक फार्म आईडी",
      recepientFarmIdStatement: "फार्मको आईडी जहाँ पशुलाल औषधि रसिद हो।",
      recepientAnimalId: "प्रापक पशु आईडी",
      recepientAnimalIdState: "जनावरको आईडी जसलाई औषधि (प्याक) तोकिएको थियो।",
      specialistComments: "विशेषज्ञ टिप्पणीहरू",
      specialistCommentsState: "प्रिस्क्रिप्शन बारे विशेषज्ञ / पशु चिकित्सा को टिप्पणी।",
      specialistName: "विशेषज्ञ नाम",
      specialistNameState: "औषधि सिफारिस गर्ने विशेषज्ञ/पशु चिकित्सकको नाम।",
      specialistID: "विशेषज्ञ आईडी",
      specialistIDState: "औषधि सिफारिस गर्ने विशेषज्ञ/पशु चिकित्सकको आईडी।",
      reservedByKeeperId: "कीपर आईडी द्वारा आरक्षित",
      reservedByKeeperIdState: "प्याक आरक्षित गर्ने व्यक्तिको किपर आईडी।",
      reservedByFarmId: "फार्म आईडी द्वारा आरक्षित",
      reservedByFarmIdState: "फार्म ID जसको लागि प्याक आरक्षित छ।",
      reservationTimeoutDate: "आरक्षण समय समाप्ति मिति",
      reservationTimeoutDateState: "प्याक खरिद नगरेको खण्डमा रिजर्भेसन स्वतः रद्द हुने मिति।",
      reservationTimeout: "आरक्षण टाइमआउट",
      reservationTimeoutState: "प्याक किनेको वा लिइएन भने रिजर्भेसन स्वतः रद्द हुने घण्टाको संख्या",
      reservationDate: "आरक्षण मिति",
      reservationDateState: "प्याकको आरक्षण मिति।",
      reservationStatus: "आरक्षण स्थिति",
      reservationStatusState: "प्याक आरक्षणको स्थिति। ",
      loadingDrugsPleaseWait: "ड्रगहरू लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      quantityOrder: "मात्रा आदेश",
      keeperID: "रक्षक आईडी",
      timeoutDate: "टाइमआउट मिति",
      warehouseID: "गोदाम आईडी",
      rackID: "र्याक आईडी",
      tierID: "टियर आईडी",
      positionID: "स्थिति आईडी",
      temperatureCondition: "तापमान अवस्था",
      manufactureDate: "निर्माण मिति",
      importedDate: "आयातित मिति",
      totalVolumeLeft: "कुल भोल्युम बायाँ"
    },
    reports: {
      myReports: "मेरा रिपोर्टहरू",
      satelliteReports: "स्याटेलाइट रिपोर्टहरू",
      weatherReports: "मौसम रिपोर्टहरू",
      pregnancyAnalytics: "गर्भावस्था विश्लेषण",
      semenEmbroyAnalytics: "वीर्य/भ्रूण विश्लेषण",
      semenAnalytics: "वीर्य विश्लेषण",
      embryoAnalytics: "भ्रूण विश्लेषण",
      calfAnalytics: "बाछो एनालिटिक्स",
      milkProduction: "दूध उत्पादन",
      totalMilkType: "कुल दूध प्रकार",
      totalAnimalAnalytics: "कुल पशु विश्लेषण",
      animalAnalytics: "पशु विश्लेषण",
      analyticsAndReporting: "विश्लेषण र रिपोर्टिङ",
      filterByCountry: "देश अनुसार फिल्टर गर्नुहोस्",
      filterByFarm: "फार्म द्वारा फिल्टर गर्नुहोस्",
      filterByRegion: "क्षेत्र अनुसार फिल्टर गर्नुहोस्",
      filterByMonth: "महिना अनुसार फिल्टर गर्नुहोस्",
      filterByDate: "मिति द्वारा फिल्टर गर्नुहोस्",
      filterByRole: "भूमिका द्वारा फिल्टर गर्नुहोस्",
      filterByYear: "वर्ष अनुसार फिल्टर गर्नुहोस्",
      filterByTrait: "विशेषता द्वारा फिल्टर गर्नुहोस्",
      avgBreedingValue: "औसत प्रजनन मूल्य",
      avgEconomicIndex: "औसत आर्थिक सूचकांक",
      breederReport: "ब्रीडर रिपोर्ट",
      semenTransferDate: "वीर्य स्थानान्तरण मिति",
      semenEmbryoProductionReport: "वीर्य/भ्रूण उत्पादन रिपोर्ट",
      semenProducts: "वीर्य उत्पादनहरू",
      meatProducts: "मासु उत्पादनहरू",
      totalProducts: "कुल उत्पादनहरू",
      semenEmbryoReport: "वीर्य/भ्रूण रिपोर्ट",
      numOfStraws: "परालहरूको संख्या",
      collectionDate: "सङ्कलन मिति",
      productionReport: "उत्पादन रिपोर्ट",
      receipientId: "प्रापक आईडी",
      embryoId: "भ्रूण आईडी",
      semenStrawId: "वीर्य स्ट्रा आईडी",
      dataScientist: "डाटा वैज्ञानिक",
      dataScientistReport: "डाटा वैज्ञानिक रिपोर्ट",
      productReport: "उत्पादन रिपोर्ट",
      dairyProducts: "दुग्ध - उत्पादन"
    },
    genoPerformance: {
      performanceOfGenoType: "जीनोटाइपको प्रदर्शन",
      addAGenoType: "GenoType थप्नुहोस्",
      breedName: "जातको नाम",
      chromosome: "क्रोमोजोम",
      sequenceChange: "अनुक्रम परिवर्तन",
      inheritance: "विरासत",
      diseaseName: "रोगको नाम",
      referenceSequence: "सन्दर्भ अनुक्रम",
      pubmedReference: "प्रकाशित सन्दर्भ",
      genoTypeRegistration: "जीनोटाइप दर्ता",
      breed: "नस्ल",
      editAGenoType: "जीनोटाइप सम्पादन गर्नुहोस्",
      editGenoType: "GenoType सम्पादन गर्नुहोस्",
      loadingGene: "जेनो लोड गर्दै... कृपया प्रतीक्षा गर्नुहोस्",
      geneTypeList: "जीनोटाइप सूची"
    },
    reportings: {
      conception: "अवधारणा (डेटा वैज्ञानिक)",
      performanceOfGenoData: "जीनोटाइपको प्रदर्शन (डेटा वैज्ञानिक)",
      totalInsemination: "कुल गर्भाधान",
      embryo: "भ्रूण",
      animalVaccinationRecord: "पशु खोप रेकर्ड",
      dataNotAvailable: "यस फार्मको लागि डाटा उपलब्ध छैन।",
      pregnancyStatus: "गर्भावस्था स्थिति",
      healthReport: "स्वास्थ्य रिपोर्ट",
      heavyMilk: "भारी दूध",
      standardMilk: "मानक दूध"
    },
    sidebar: {
      healthAnalytics: "स्वास्थ्य विश्लेषण",
      productionAnalytics: "उत्पादन विश्लेषण"
    },
    epd: {
      regNo: "Animal Reg No विशेष जनावरहरू पहिचान गर्न र ट्र्याक गर्नको लागि गरिएको प्रक्रिया सुनिश्चित गर्ने, चिन्ह लगाउने माध्यम प्रयोग गरेर जनावरहरूलाई दिइएको अद्वितीय कोड हो।",
      internationalID: "जनावरको अन्तर्राष्ट्रिय आईडी",
      location: "देश / पशु जन्म क्षेत्र ",
      animalName: "पशुको मानक नाम / नामकरण",
      gender: "जनावरको लिंग (पुरुष/महिला)",
      additionalIDMethod: "जनावर पहिचान गर्न कुन विधि प्रयोग गरियो (जस्तै कान ट्याग, ट्याटु)",
      damID: "जनावरको बाँधको परिचयपत्र वा दर्ता नम्बर - जनावरको महिला अभिभावक/जैविक आमाको संख्याको आईडी",
      sireId: "जनावरको पुरुष अभिभावकको परिचय वा दर्ता नम्बर, विशेष गरी प्रजननका लागि राखिएको गोरु वा कृत्रिम गर्भाधानका लागि प्रयोग गरिने गोरुको वीर्य।",
      dateOfBirth: "जनावरको जन्म मिति।",
      breederHerdCode: "ब्रीडर हर्ड कोड प्रायः ब्रीडर एसोसिएसनहरू द्वारा दिइन्छ",
      seasonofBirth: "जनावरको जन्मको मौसम महिना अनुसार उल्लेख गरिएको छ",
      birthYear: "जनावर जन्मेको वर्ष",
      birthManagementCode: "जन्म व्यवस्थापन कोड प्रायः प्रयोगकर्ता/किसान द्वारा प्रदान गरिएको छ",
      birthSex: "जनावरको लिंग (पुरुष/महिला)",
      birthWeight: "बाछोको जन्म वजन ",
      primaryBreed: "जनावरको प्रमुख % आनुवंशिक योगदान ",
      secondaryBreed: "माइनर % जनावरको आनुवंशिक योगदान ",
      breedComposition: "नस्ल संरचना प्रतिशतले व्यक्तिगत जनावर वा जनावरहरूको समूहको आनुवंशिक श्रृङ्खला भित्र विभिन्न नस्लहरूको समानुपातिक प्रतिनिधित्वलाई जनाउँछ। ",
      conceptionMethod: "जनावरको गर्भ कसरी भयो (प्राकृतिक संभोग / गर्भाधान / भ्रूण स्थानान्तरण)।",
      accuracyWeight: "शुद्धता वजन",
      damAge: "महिना/वर्षमा बाँधको उमेर जस्तै ",
      weaningWeight: "दूध छुटाउने समयमा जनावरको वजन।",
      weaningDate: "जनावरको दूध छुटाइएको मिति",
      weaningSex: "दूध छुटाइएको जनावरको लिङ्ग। ",
      managementPastureCode: "प्रयोगकर्ता/कृषकद्वारा व्यवस्थापन/चरनलाई दिइएको कोड ",
      creep: "क्रिप फिडिङ भनेको नर्सिङ बाछोहरूलाई पूरक दाना (अनाज वा चारा) उपलब्ध गराउने अभ्यास हो।",
      weaningContemporaryGroupCode: "दूध छुटाउने तौल समकालीन समूहको कोड",
      birthContemporaryCode: "जन्म समकालीन कोड",
      yearlingDate: "एक वर्ष पुरानो वा आफ्नो उमेर को दोस्रो वर्ष मा जनावर को मिति",
      managementFeedUnitCode: "प्रयोगकर्ताद्वारा व्यवस्थापन/फिड एकाइलाई दिइएको कोड",
      yearlingSex: "वर्षको समयमा जनावरको लिङ्ग ",
      yearlingWeight: "Yearling Weight भनेको दूध छुटाइपछिको प्रत्यक्ष वृद्धिको मापन हो र प्रायः फिडलोटमा बजार-बाउन्ड सन्तानको सम्भावित कार्यसम्पादनलाई प्रतिबिम्बित गर्न प्रयोग गरिन्छ, बाछोको पाउण्डमा मापन गरिन्छ।",
      yearlingHeight: "वर्षको समयमा जनावरको उचाइ ",
      yearlingWeightContemporaryGroupCode: "वार्षिक वजन समकालीन समूहको कोड",
      weaningYearlingWeightContemporaryGroupCode: "दूध छुटाउने वा वार्षिक वजन समकालीन समूहको कोड",
      daysOnFeed: "त्यो विशेष फीडको साथ खुवाइएको दिनहरूको संख्या जस्तै: युवा बढ्दै गाईवस्तुहरूलाई कम लागतमा बजारयोग्य गाईको मासु उत्पादन गर्न उच्च ऊर्जा आहार खुवाइन्छ। ",
      managementFeedUnitPenCode: "प्रयोगकर्ताद्वारा व्यवस्थापन/फिड इकाई/पेनलाई दिइएको कोड",
      harvestDate: "मासुको लागि पशु मारिएको (मारिएको) मिति",
      gradingDate: "शवको मिति विशेष मापदण्ड अनुसार वर्गीकरण गरिएको थियो",
      carcassSex: "शवको लिंग",
      dateonFeed: "जनावरलाई नयाँ दानामा सारिएको मिति जस्तै: युवा बढ्दो गाईवस्तुहरूलाई कम लागतमा बजारयोग्य गाईको मासु उत्पादन गर्न उच्च ऊर्जा आहार खुवाइन्छ। ",
      KPH: "% KPH भनेको शवको शरीरको गुफामा पाइने कुल बोसोको प्रतिशत हो, विशेष गरी मृगौला, श्रोणि र मुटुको क्षेत्रहरूमा। ",
      carcassWeight: "शवको तौल बालीको छाला, टाउको, ग्यास्ट्रोइंटेस्टाइनल ट्र्याक्ट र भित्री अंगहरू हटाउने र हटाउने पछि तातो वा नचिल्ने तौल हो। ",
      fatThickness: "फ्याट मोटाई सानो शासक प्रयोग गरेर इन्च मा मापन गरिन्छ। ",
      marbling: "मार्बलिङ भनेको मांसपेशी भित्र र मांसपेशी फाइबर बन्डलहरू बीच जम्मा हुने असंतृप्त (स्वस्थ) इन्ट्रामस्कुलर फ्याट हो।",
      ribeyeArea: "रिब-आँखाको मात्रा (कम्बर वा ribeye मांसपेशी longissimus dorsi) क्षेत्र ग्रिड प्रयोग गरेर वर्ग इन्च मा 12 औं र 13 औं रिब बीच मापन (जस्तै, 8, 9 वा 10 इन्च)। ",
      animalStatus: "फार्ममा जनावरको स्थिति जस्तै: खेतमा, बेचेको, मरेको आदि"
    },
    manageAnimalGroupings: {
      resetModeTooltip: "रिसेट मोड <br>  यस मोडमा <br> 1) रुचिका सबै विशेषताहरूका लागि सबै समकालीन समूहहरू (CGs) विशेषताहरू सेट/परिभाषित गर्नुहोस्। <br>  2) सबै जनावरहरूलाई सम्बन्धित CG मा असाइन गर्नुहोस्। <br>   3) यदि जनावरहरूको असाइनिङ सन्तोषजनक छैन भने, CGs समायोजन / परिवर्तन गर्नुहोस्, र त्यसपछि फेरि नयाँ सम्बन्धित CGs मा जनावरहरू असाइन गर्नुहोस्। <br>  4) यदि आवश्यक भएमा, माथिका चरणहरू दोहोर्याउनुहोस्, जबसम्म तपाईं CGs र जनावरहरूको संगत समूह/असाइनिङमा सन्तुष्ट हुनुहुन्न।<br>",
      maintainanceModeHeadingTooltip: "एकपटक RESET (मोड) फाइनल भएपछि, तपाईंले MAINTENANCE MODE मा प्रवेश गर्नुहुनेछ जहाँ RESET मा गणना गरिएको EDPs अर्को RESET (जुन 2-6 महिना टाढा हुन सक्छ) सम्म प्रत्येक जनावरको लागि स्थिर रहनेछ। ",
      maintainanceModeTooltip: "रिसेट मोड पूरा गरिसकेपछि, प्रणालीलाई सबै जनावरहरूको EPD गणना गर्न सक्षम पार्न, रिसेट मोड समाप्त गर्नुहोस्, र मर्मत मोड प्रारम्भ गर्न RESET FINALIZED बटन थिच्नुहोस्।",
      resetToggleTooltip: "CGs मा जनावरहरू तोक्न EPD मोडेल सेटिङमा रिसेट टगल सक्षम गर्नुहोस्।"
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "आनुवंशिकी",
      geneticSearchTool: "आनुवंशिक खोज उपकरण",
      dataSubmission: "डाटा सबमिशन",
      animalsWithExpectedProgenyDifferences: "अपेक्षित सन्तान भिन्नता भएका जनावरहरू (EPDs)",
      searchByAnimalIdName: "पशु आईडी, नाम द्वारा खोज्नुहोस्",
      rowsPerPage: "प्रति पृष्ठ पङ्क्तिहरू",
      individualEntry: "व्यक्तिगत प्रविष्टि",
      bulkEntry: "बल्क प्रविष्टि",
      registerANewAnimalOrSelectAnExistingAnimal: "नयाँ जनावर दर्ता गर्नुहोस् वा अवस्थित जनावर चयन गर्नुहोस्।",
      registerNewAnimal: "नयाँ जनावर दर्ता गर्नुहोस्",
      selectExistingAnimal: "अवस्थित जनावर चयन गर्नुहोस्",
      animalID: "पशु आईडी",
      animalName: "जनावरको नाम",
      tag: "ट्याग",
      dateOfBirth: "जन्म मिति",
      gender: "लिङ्ग",
      birthDate: "जन्म मिति",
      birthWeightLb: "जन्म तौल (lb)",
      birthWeightKg: "जन्म वजन (किग्रा)",
      weaningWeightLb: "दूध छुटाउने वजन (lb)",
      weaningWeightKg: "दूध छुटाउने वजन (किग्रा)",
      yearlingWeightLb: "वार्षिक वजन (lb)",
      yearlingWeightKg: "वार्षिक वजन (किग्रा)",
      carcassWeightLb: "शवको वजन (lb)",
      carcassWeightKg: "शवको वजन (किग्रा)",
      animalSelection: "पशु चयन",
      animalSearchTool: "पशु खोज उपकरण",
      back: "पछाडि",
      searchByEPDs: "EPDs द्वारा खोज्नुहोस्",
      searchByIds: "आईडी द्वारा खोज्नुहोस्",
      selectBreed: "नस्ल चयन गर्नुहोस्",
      selectGender: "लिङ्ग चयन गर्नुहोस्",
      selectRequiredBreedForCattle: "गाईवस्तुको लागि आवश्यक नस्ल चयन गर्नुहोस्",
      resetFilter: "फिल्टर रिसेट गर्नुहोस्",
      birthWeightHeader: "जन्म तौल (BW): ",
      birthWeightDef: "जन्मको समयमा बाछोको तौलमा भिन्नताहरू तुलना गर्नुहोस् र पाउन्ड वा किलोग्राम मा मापन गरिन्छ।",
      weaningWeightHeader: "दूध छुटाउने वजन (WW): ",
      weaningWeightDef: "WW EPD भनेको पाउन्ड वा kg मा नापिएको पूर्व-स्वास्थ्य वृद्धिको अनुमान हो।",
      yearlingWeightHeader: "वार्षिक वजन (YW): ",
      yearlingWeightDef: "YW EPD पाउंड वा kg मा नापिएको पोस्ट-वेनिंग वृद्धिको अनुमान हो।",
      ribEyeAreaHeader: "रिबे क्षेत्र (REA): ",
      ribEyeAreaDef: "REA ले मांसपेशीको आकार नाप्छ जसले हामीलाई वर्ग इन्चमा ribeye दिन्छ। REA EPDs ले काटिएका गाईवस्तुहरूको शवको मापनमा आधारित 365-दिनको रिबेइ क्षेत्र मापनमा भिन्नताहरू प्रतिबिम्बित गर्दछ।",
      marblingHeader: "मार्बलिङ (MARB): ",
      marblingDef: "MARB EPD ribeye भित्रको इन्ट्रामस्कुलर फ्याटको प्रतिशतको एकाइमा हुन्छ। MARB EPD ले काटिएका गाईवस्तुहरूको शव मापनको आधारमा समायोजित 365-दिनको मार्बलिङ स्कोर (इन्ट्रामस्कुलर फ्याट, [IMF]) मा भिन्नताहरू प्रतिबिम्बित गर्दछ।",
      fatThicknessHeader: "बोसो मोटाई (FAT): ",
      fatThicknessDef: "ब्याकफ्याटको इन्च (इन्चको सयौं भागमा) FT को मापनको एकाइ हो।",
      carcassWeightHeader: "शवको वजन (CW): ",
      carcassWeightDef: "शवको वजन एक लाभदायक विशेषता हो जब पाउन्डले उत्पादन मूल्यको सापेक्ष प्रभावलाई विचार गर्दछ। ",
      yieldGradeHeader: "उपज ग्रेड (YG): ",
      yieldGradeDef: "USDA यील्ड ग्रेड स्कोरिङ प्रणाली YG EPD को मापनको एकाइ हो। ",
      milkHeader: "दूध (MK): ",
      milkDef: "MK EPD आमाको दूध पिउने क्षमताको कारण बाछोको दूध छुटाउने तौलको पाउन्डमा मापन गरिन्छ।",
      totalMaternalHeader: "कुल मातृ (TM): ",
      totalMaternalDef: "TM ले दूध उत्पादन र वृद्धिको लागि गाईको आनुवंशिकी दुवैको कारणले बाछोको दूध छुटाउने वजनमा असर गर्छ।",
      calvingEaseDirectHeader: "Calving Ease Direct (CED): ",
      calvingEaseDirectDef: "CED EPD लाई असिस्टेड बाछोको प्रतिशतको रूपमा सूचीबद्ध गरिएको छ।",
      calvingEaseMaternalHeader: "Calving Ease Maternal (CEM): ",
      calvingEaseMaternalDef: "साँढेका छोरीहरूको दुई वर्षको बच्चाको रूपमा सहायता नगरिएको बाछोहरूको क्षमता मापन गर्दछ।",
      stayabilityHeader: "स्थिरता (रहने): ",
      stayabilityDef: "ST EPD ले गोरुको \"वरपर बस्ने\" गाईहरूलाई टाउको दिने क्षमताको भविष्यवाणी गर्छ।",
      docilityHeader: "व्यवहारिकता (DOC): ",
      docilityDef: "DOC ले गाईवस्तुको स्वभाव नाप्छ।",
      max: "MAX",
      min: "MIN",
      accuracy: "शुद्धता",
      sortBy: "क्रमबद्ध गर्नुहोस्",
      traits: "खैरो रंगमा देखाइएका विशेषताहरू विकासको क्रममा छन्, Q2, 2023 मा आउँदैछन्।",
      searchResults: "खोज परिणामहरू",
      recordsFound: "अभिलेख भेटियो",
      compareSelected: "चयन गरिएको तुलना गर्नुहोस्",
      animalIdentification: "पशु पहिचान",
      errorMessage: {
        birthWeight: "जन्म तौल अधिकतम मान जन्म वजन न्यूनतम भन्दा कम हुन सक्दैन",
        weaningWeight: "दूध छुटाउने तौलको अधिकतम मूल्य न्यूनतम वजनभन्दा कम हुन सक्दैन",
        yearlingWeight: "वार्षिक तौल अधिकतम मान वार्षिक वजन न्यूनतम भन्दा कम हुन सक्दैन",
        carcassWeight: "शवको तौल अधिकतम मान जन्मको न्यूनतम तौलभन्दा कम हुन सक्दैन",
        fatThickness: "फ्याट थिकनेस अधिकतम मान Weaning वजन न्यूनतम भन्दा कम हुन सक्दैन",
        marbling: "मार्बलको अधिकतम मूल्य वार्षिक वजन न्यूनतम भन्दा कम हुन सक्दैन",
        ribeyeArea: "Ribeye क्षेत्र अधिकतम मान जन्म वजन न्यूनतम भन्दा कम हुन सक्दैन",
        yieldGrade: "उपज ग्रेड अधिकतम मान Weaning वजन न्यूनतम भन्दा कम हुन सक्दैन",
        milk: "दूधको अधिकतम मूल्य दूध छुटाउने तौल न्यूनतम भन्दा कम हुन सक्दैन"
      },
      reg: "Reg",
      name: "नाम",
      sex: "सेक्स",
      tattoo: "ट्याटु",
      dob: "DOB",
      EPD: "EPD",
      rank: "श्रेणी",
      searchValue: "खोज मान",
      typeHere: "यहाँ टाइप गर्नुहोस्",
      searching: "खोज्दै...",
      fetchingResult: "परिणामहरू प्राप्त गर्दै...कृपया पर्खनुहोस्",
      animalsMatchedYourCriteria: "जनावरहरूले तपाईंको मापदण्डसँग मेल खाए",
      manageAnimalsGrouping: "पशु समूह व्यवस्थापन गर्नुहोस्",
      manageAnimalGroupings: "पशु समूह व्यवस्थापन गर्नुहोस्",
      assignAnimalToContemporaryGroups: "समकालीन समूहहरूलाई जनावर असाइन गर्नुहोस्",
      resetMode: "रिसेट मोड",
      enterResetMode: "रिसेट मोड प्रविष्ट गर्नुहोस्",
      maintainanceMode: "मर्मत मोड",
      assigningAnimals: "पशु तोक्ने",
      excludedAnimals: "बहिष्कृत जनावरहरू",
      ungroupedAnimals: "समूह नगरिएका जनावरहरू",
      assignAnimalsToCGS: "CGS लाई जनावरहरू असाइन गर्नुहोस्",
      reset: "रिसेट गर्नुहोस्",
      excludeAnimals: "जनावरहरू बहिष्कार गर्नुहोस्",
      resetToMaintainanceMode: "रिसेट फाइनल - मर्मत मोडमा परिवर्तन गर्नुहोस्",
      contemporaryGroupsSettings: "समकालीन समूह (CG) सेटिङहरू",
      selectTrait: "विशेषता चयन गर्नुहोस्",
      selectTraitDescription:"चयन विशेषताले विशिष्ट विशेषता छनौट गर्ने प्रक्रियालाई बुझाउँछ",
      traitsType: {
        birthWeight: "जन्म वजन",
        weaningWeight: "छुटाउने वजन",
        yearlingWeight: "वार्षिक वजन",
        carcassWeight: "शवको वजन"
      },
      addNewGroup: "नयाँ समूह थप्नुहोस्",
      contemporaryGroup: "समकालीन समूह",
      contemporaryGroups: "समकालीन समूहहरू",
      editGroup: "समूह सम्पादन गर्नुहोस्",
      birthCGCode: "जन्म (CG) कोड",
      groupName: "समूहको नाम",
      birthSex: "जन्म लिङ्ग",
      conceptionMethod: "अवधारणा विधि",
      weaningCGCode: "दूध छुटाउने (CG) कोड",
      yearlingCGCode: "वार्षिक (CG) कोड",
      dateWeight: "मिति वजन",
      weaningyearlingCGcode: "दूध छुटाउने/वार्षिक (CG) कोड",
      carcassCGCode: "शव (CG) कोड",
      breedOfDom: "बाँध को जात",
      addNewContemporaryGroup: "नयाँ समकालीन समूह थप्नुहोस्",
      createNewGroup: "नयाँ समूह सिर्जना गर्नुहोस्",
      selectFromDifferentTraits: "विभिन्न विशेषताहरूबाट चयन गर्नुहोस्",
      contemporaryGroupName: "समकालीन समूह नाम",
      enterNameHere: "यहाँ नाम प्रविष्ट गर्नुहोस्",
      groupNameIsRequired: "समूहको नाम आवश्यक छ",
      birthYearRange: "जन्म वर्ष दायरा",
      theYearAnimalWasBorn: "वर्ष पशु जन्मिएको थियो",
      birthYearIsRequired: "जन्म वर्ष आवश्यक छ",
      genderOfNewBornAnimal: "नवजात जनावरको लिङ्ग",
      selectSex: "सेक्स चयन गर्नुहोस्",
      theweightOfAnimalAtBirth: "जन्मदा जनावरको वजन",
      maximumKg: "अधिकतम",
      minimumKg: "न्यूनतम",
      aSeasonisAPeriodOfYear: "सिजन भनेको वर्षको अवधि हो जुन विशेष हावापानी अवस्थाहरूद्वारा छुट्याइन्छ।",
      seasonofBirthIsRequired: "जन्म सिजन आवश्यक छ",
      majorGenericContributionOfAnimal: "पशुको प्रमुख % सामान्य योगदान",
      primaryBreedCompostionIsRequired: "प्राथमिक नस्ल रचना आवश्यक छ",
      secondaryBreedCompostionIsRequired: "माध्यमिक नस्ल रचना आवश्यक छ",
      howTheAnimalWasConceived: "जनावरको गर्भ कसरी भयो (प्राकृतिक संभोग / गर्भाधान / भ्रूण स्थानान्तरण)",
      conceptionMethodIsRequired: "अवधारणा विधि आवश्यक छ",
      epdModelSettings: "EPD मोडेल सेटिङहरू",
      forResetMode: "रिसेट मोड को लागी",
      progenyWeightingFactor: "प्रोजेनी वजन कारक",
      weightGivenToTheProgenyFactor: "रिसेट मोडमा EPD गणनाको लागि CG कारकको सापेक्ष सन्तान कारकलाई दिइएको वजन। ",
      enterNumber: "नम्बर प्रविष्ट गर्नुहोस्",
      enterBreed: "नस्ल प्रविष्ट गर्नुहोस्",
      valueShouldBeBetween0and1: "मान ० र १ को बीचमा हुनुपर्छ",
      resetDuration: "रिसेट अवधि",
      timeIntervalBetweenLastAndFirstResetMode: "पछिल्लो र नयाँ रिसेट मोड बीचको समय अन्तराल, जसको अन्त्यमा नयाँ रिसेट मोड सक्षम गरिएको छ र नयाँ CGs र EPDs गणना गरिन्छ।",
      enterNumberOfDays: "दिनहरूको संख्या प्रविष्ट गर्नुहोस्",
      valueCannotBeNegative: "मूल्य नकारात्मक हुन सक्दैन!",
      criticalProgenyPopulation: "क्रिटिकल प्रोजेनी जनसंख्या",
      minimumNumberOfProgenyRecords: "५०% भन्दा माथि प्रोजेनी एक्युरेसी (APD1) प्राप्त गर्न आवश्यक प्रणालीमा व्यक्तिगत जनावरको सन्तान रेकर्डको न्यूनतम संख्या (वंशावली शुद्धताका लागि)",
      criticalAncestorPopulation: "आलोचनात्मक पूर्वज जनसंख्या",
      minimumNumberOfAncestorsRecords: "एन्सेस्टर एक्युरेसी (APD4) ५०% माथि (वंशावली शुद्धताका लागि) प्राप्त गर्न आवश्यक पर्ने प्रणालीमा व्यक्तिगत जनावरको पुर्खाहरूको न्यूनतम संख्या",
      forBirthWeightCG: "जन्म वजन CG को लागी",
      criticalPopulationInAnimalsContemporaryGroup: "पशुको समकालीन समूहमा आलोचनात्मक जनसंख्या",
      minimumAverageNumberOfAnimalsPerBirthWeight: "५०% भन्दा माथि औसत CG एक्युरेसी (ACG3) प्राप्त गर्नका लागि प्रति जन्म तौल CG आवश्यक पर्ने जनावरहरूको न्यूनतम औसत संख्या",
      criticalAveragePopulationPerContemporaryGroup: "प्रति समकालीन समूह क्रिटिकल औसत जनसंख्या",
      minimumNumberOfAnimalsInBirthWeight: "५०% भन्दा माथि CG एक्युरेसी (ACG2) प्राप्त गर्नको लागि जनावरको जन्म तौल CG मा जनावरहरूको न्यूनतम संख्या आवश्यक छ।",
      forWeaningWeightCG: "दूध छुटाउने वजन CG को लागी",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "५०% भन्दा माथिको औसत CG एक्युरेसी (ACG3) प्राप्त गर्न आवश्यक पर्ने जनावरहरूको न्यूनतम औसत संख्या प्रति छुटाउने वजन CG",
      minimumNumberOfAnimalsInWeaningWeight: "५०% भन्दा माथि CG एक्युरेसी (ACG2) प्राप्त गर्नका लागि जनावरको दूध छुटाउने तौल CG मा जनावरहरूको न्यूनतम संख्या आवश्यक छ।",
      forYearlingWeightCG: "वार्षिक वजन CG को लागी",
      minimumAverageNumberOfAnimalsPerYearling: "५०% भन्दा माथि औसत CG एक्युरेसी (ACG3) प्राप्त गर्नको लागि प्रति वार्षिक CG आवश्यक पर्ने जनावरहरूको न्यूनतम औसत संख्या",
      minimumNumberOfAnimalsInYearlingWeight: "५०% भन्दा माथि CG एक्युरेसी (ACG2) प्राप्त गर्न पशुको वार्षिक वजन CG मा जनावरहरूको न्यूनतम संख्या आवश्यक छ।",
      forCarcassCG: "शव CG को लागी",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "५०% भन्दा माथि औसत CG एक्युरेसी (ACG3) प्राप्त गर्न आवश्यक पर्ने प्रति शव वजन CG जनावरहरूको न्यूनतम औसत संख्या",
      minimumNumberOFAnimalInCarcassWeight: "५०% भन्दा माथि CG एक्युरेसी (ACG2) प्राप्त गर्न जनावरको शवको तौल CG मा जनावरहरूको न्यूनतम संख्या आवश्यक छ।",
      epdRequiredFieldSettings: "EPD आवश्यक क्षेत्र सेटिङहरू",
      pleaseSelectRequiredFieldsForCompleteEPD: "कृपया पूर्ण EPD गणनाको लागि आवश्यक क्षेत्रहरू चयन गर्नुहोस्",
      byDefault: "पूर्वनिर्धारित",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "नोट: कृपया ध्यान दिनुहोस् कि प्रयोगकर्ताहरूले पूर्ण EPD गणना प्राप्त गर्न सक्ने छैनन् यदि तिनीहरूले डेटा फिल्डहरू प्रदान गर्दैनन् जुन तपाईंले आवश्यक रूपमा चिन्ह लगाउनु भएको छ।",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "नोट: कृपया ध्यान दिनुहोस् कि आवश्यक फिल्ड प्यारामिटरहरू परिवर्तन गर्न सकिँदैन किनभने पहिले नै अघिल्लो प्यारामिटरहरू विरुद्ध समकालीन समूहहरू छन्।",
      noResultFound: "कुनै परिणाम फेला परेन",
      next: "अर्को",
      cancel: "रद्द गर्नुहोस्",
      selectAnimal: "जनावर चयन गर्नुहोस्",
      searchBy: "द्वारा खोज्नुहोस्",
      breed: "नस्ल",
      regDate: "Reg. ",
      status: "स्थिति",
      animalDetails: "पशु विवरण",
      add: "थप्नुहोस्",
      update: "अपडेट गर्नुहोस्",
      dataForEPDs: " EPD को लागि डाटा",
      basicInformation: "आधारभूत जानकारी",
      birthWeightInformation: "जन्म वजन जानकारी",
      weaningWeightInformation: "दूध छुटाउने वजन जानकारी",
      yearlingWeightInformation: "वार्षिक वजन जानकारी",
      carcassWeightInformation: "शव वजन जानकारी",
      delete: "मेटाउन",
      deleteEpdData: "EPD डाटा मेटाउनुहोस्",
      areYouSureYouWantToDeleteEpdData: "के तपाइँ निश्चित हुनुहुन्छ कि तपाइँ EPD डाटा मेटाउन चाहनुहुन्छ।",
      internationalID: "अन्तर्राष्ट्रिय आईडी",
      enterID: "आईडी प्रविष्ट गर्नुहोस्",
      animalRegistration: "पशु दर्ता",
      location: "स्थान",
      additionalIDMethod: "थप आईडी विधि",
      damID: "बाँध आईडी",
      sireID: "सर आईडी",
      breederHerdCode: "ब्रीडर हर्ड कोड",
      birthYear: "जन्म वर्ष",
      primaryBreed: "प्राथमिक नस्ल",
      breedComposition: "नस्ल संरचना",
      secondaryBreed: "माध्यमिक नस्ल",
      seasonofBirth: "जन्मको मौसम",
      birthManagementCode: "जन्म व्यवस्थापन कोड",
      damAge: "बाँध युग",
      years: "वर्षहरू",
      birthContemporaryCode: "जन्म समकालीन कोड",
      accuracyWeight: "शुद्धता वजन",
      note: "नोट",
      minimumRequiredFieldForBirthWeight: "जन्म वजन EPDs को लागि न्यूनतम आवश्यक क्षेत्र",
      birthYearGenderConceptionMethodBirthWeight: "जन्म वर्ष, लिङ्ग, गर्भाधान विधि, जन्म तौल",
      weaningWeight: "छुटाउने वजन",
      weaningDate: "दूध छुटाउने मिति",
      weaningContemporaryGroupCode: "समकालीन समूह कोड छुटाउने",
      creep: "छिर्न",
      managementPastureCode: "व्यवस्थापन/चरन कोड",
      weaningSex: "दूध छुटाउने सेक्स",
      minimumRequiredFieldForWeaningWeight: "Weaning Weight EPDs को लागि न्यूनतम आवश्यक क्षेत्र",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "दूध छुटाउने तौल , व्यवस्थापन / चरन कोड , दूध छुटाउने लिंग , तौलिएको मिति",
      yearlingWeight: "वार्षिक वजन",
      yearlingHeight: "वार्षिक उचाइ",
      yearlingDate: "वार्षिक मिति",
      yearlingContemporaryGroupCode: "वार्षिक समकालीन समूह कोड",
      managementFeedingCode: "व्यवस्थापन/फिडिङ कोड",
      yearlingSex: "वार्षिक सेक्स",
      youWillNeedToFillOutFor: "तपाईंले को लागि EPD डाटा पुन: प्राप्त गर्न सबै क्षेत्रहरू भर्न आवश्यक हुनेछ",
      pleaseSelectHavestDateFirstToEnterInfo: "रिब आँखा क्षेत्र, फ्याट थिकनेस र मार्बलिङका लागि जानकारी प्रविष्ट गर्न कृपया पहिले 'फसल मिति' चयन गर्नुहोस्",
      harvestDate: "फसल मिति",
      dateOnFeed: "फिडमा मिति",
      daysOnFeed: "फिडमा दिनहरू",
      gradingDate: "ग्रेडिङ मिति",
      carcassSex: "शव सेक्स",
      carcassWeight: "शवको वजन",
      carcassContemporary: "शव समकालीन",
      damBreed: "बाँध नस्ल",
      ribEyeArea: "रिब आँखा क्षेत्र",
      ribEyeAreaContemporary: "रिब आँखा क्षेत्र समकालीन",
      fatThickness: "बोसो मोटाई",
      fatThicknessContemporary: "फ्याट थिकनेस समकालीन",
      marbling: "मार्बलिङ",
      marblingContemporary: "मार्बलिंग समकालीन",
      yieldGradeContemporary: "उपज ग्रेड समकालीन",
      animalsNotListedInContemporaryGroupsMsg: "हराइरहेको जानकारीको कारण कुनै पनि समकालीन समूहहरूमा जनावरहरू थपिएका छैनन्। ",
      listOfUngroupedAnimals: "समूह नगरिएका जनावरहरूको सूची",
      submittingData: "डाटा पेश गर्दै",
      resendToUser: "प्रयोगकर्तालाई पुन: पठाउनुहोस्",
      submittingAnimalsInGroupMsg: "तपाईंको जनावरहरूलाई समूहमा पेस गर्दै। ",
      pressingResetBtnMsg: "\"रिसेट\" बटन थिच्दा जनावरहरूलाई तिनीहरूको समकालीन समूहहरूमा पुन: असाइन गर्ने प्रक्रिया सुरु हुनेछ।",
      doYouWantToProceed: "के तपाई अगाडि बढ्न चाहनुहुन्छ?",
      systemMaintainanceModeMsg: "\"मेन्टेनन्स मोडमा परिवर्तन गर्नुहोस्\" बटन थिच्दा एउटा प्रक्रिया सुरु हुनेछ र तपाईंको प्रणालीले \"मेन्टेन्स मोड\" मा प्रवेश गर्नेछ जहाँ रिसेटमा गणना गरिएको EDP हरू अर्को रिसेट (जुन १-६ महिनासम्म हुन सक्छ) प्रत्येक जनावरको लागि स्थिर रहनेछ।",
      errorFetchingContemporaryGrpMsg: "समकालीन समूह डेटा ल्याउन त्रुटि",
      deleteSuccess: "सफलता मेटाउनुहोस्",
      deleteSuccessMsg: "समकालीन समूह सफलतापूर्वक मेटाइयो।",
      deleteFailed: "मेटाउन सकिएन",
      deleteFailedMsg: "समकालीन समूह डेटा मेटाउँदा त्रुटि",
      deleteContemporaryGrpMsg: "के तपाइँ यो समकालीन समूह मेटाउन निश्चित हुनुहुन्छ?",
      addBirthWeightData: "जन्म वजन डाटा थप्नुहोस्",
      addWeaningWeightData: "Weaning वजन डाटा थप्नुहोस्",
      birthWeightContemporaryGroupCode: "जन्म वजन समकालीन समूह कोड",
      dateWeighted: "मिति वजन",
      addYearlingWeightData: "वार्षिक वजन डाटा थप्नुहोस्",
      addCarcassWeightData: "शवको वजन डाटा थप्नुहोस्",
      weaningOrYearlingContemporaryGroupCode: "दूध छुटाउने वा वार्षिक वजन समकालीन समूह कोड",
      deleteContemporaryGroupMsg: "के तपाईँ समकालीन समूह मेटाउन निश्चित हुनुहुन्छ?",
      updateSuccessMsg: "समकालीन समूह सफलतापूर्वक अपडेट भयो।",
      errorMsg: "केहि गलत भयो। ",
      fetchErrorMsg: "चयन गरिएको विशेषताका लागि आवश्यक क्षेत्रहरू ल्याउन त्रुटि भयो।",
      forMaintainanceMode: "रखरखाव मोड को लागी",
      ancestorsWeightFactor: "पूर्वज वजन कारक",
      weightGivenToTheAncestorFactor: "मर्मत मोडमा EPD गणनाको लागि CG कारकसँग सम्बन्धित पूर्वज कारकलाई दिइएको वजन। ",
      addEPDModelSettingsData: "EPD मोडेल सेटिङ डेटा थप्नुहोस्",
      minimumNumberOfAnimalsInContemporaryGroups: "समकालीन समूहहरूमा जनावरहरूको न्यूनतम संख्या",
      enterNumberOfAnimals: "जनावरहरूको संख्या प्रविष्ट गर्नुहोस्",
      areYouSureYouWantToChangeEPDCalculation: "के तपाइँ आवश्यक EPD गणना क्षेत्रहरू परिवर्तन गर्न निश्चित हुनुहुन्छ?",
      weightOfAnimalAtBirth: "जन्मदा जनावरको तौल",
      seasonIsAPeriodOfYear: "सिजन भनेको वर्षको अवधि हो जुन विशेष हावापानी अवस्थाहरूद्वारा छुट्याइन्छ।",
      codeOfBirthWeightContemporaryGroup: "जन्म वजन समकालीन समूह को कोड",
      weaningWeightOfCalf: "बाछोको दूध छुटाउने वजन",
      dateAnimalWasWeaned: "जनावरको दूध छुटाइएको मिति",
      genderOfWeaningAnimal: "दूध छुटाउने जनावरको लिंग",
      yearlingWeightOfCalf: "बाछोको वार्षिक वजन",
      dateAnimalWasWeighted: "जनावरको तौल भएको मिति",
      yearledAnimalSex: "जनावरको लिंग जुन वर्षको थियो",
      dateOfAnimalKilledForMeat: "मासुको लागि मारिएको जनावरको मिति",
      addSuccessMsg: "समकालीन समूह सफलतापूर्वक थपियो",
      traitH: "EPD गणनाको लागि विशेषता।",
      searchByValue: "दर्ता नम्बर/टैटू/नाम/ट्याग प्रविष्ट गर्नुहोस्"
    }
  }